import { DataSeriesOverTime } from "../interface"

// Data from https://github.com/TheWorldSim/world-sim/blob/main/sims/energy-explorer/Assets/Data/power_demand/PowerDemandUK2018Data.cs#L40
export const UK_demand_GW_by_hour_2018 = [
26.35
,26.76
,27.01
,25.95
,25.01
,23.91
,23.85
,24.91
,24.64
,25.62
,28.06
,30.31
,32.14
,33.05
,33.46
,33.59
,34.63
,37.83
,39.42
,38.04
,36.17
,33.81
,31.44
,28.62
,26.81
,26.58
,26.74
,26.29
,26.27
,26.08
,26.80
,29.84
,34.09
,37.36
,40.14
,41.37
,41.88
,42.33
,42.12
,41.75
,42.26
,44.61
,46.14
,45.08
,42.56
,39.28
,35.23
,30.86
,27.55
,26.98
,26.62
,26.44
,26.06
,25.89
,26.45
,29.69
,34.64
,37.67
,39.11
,39.06
,39.03
,39.21
,39.32
,40.03
,41.18
,44.06
,46.08
,45.14
,43.33
,40.32
,36.46
,32.46
,29.86
,30.08
,29.60
,29.03
,28.68
,28.50
,29.68
,32.94
,38.06
,40.50
,41.51
,41.18
,41.34
,41.36
,41.15
,41.04
,41.96
,44.96
,46.84
,46.06
,44.14
,41.27
,37.59
,33.71
,30.79
,30.79
,30.36
,29.42
,28.77
,28.35
,29.36
,32.88
,38.28
,41.25
,42.54
,42.65
,42.66
,42.59
,42.34
,42.30
,42.99
,45.30
,47.10
,46.33
,44.44
,41.66
,38.06
,34.19
,30.99
,30.01
,29.40
,28.55
,28.27
,27.48
,27.30
,28.87
,30.32
,33.35
,36.12
,37.05
,36.96
,36.99
,36.82
,36.86
,37.72
,41.15
,43.39
,42.70
,40.83
,38.38
,35.71
,32.90
,30.25
,29.47
,29.66
,29.02
,28.36
,27.62
,27.48
,28.45
,29.56
,30.79
,33.54
,34.85
,35.33
,35.70
,35.89
,36.87
,39.15
,43.49
,46.18
,44.99
,42.77
,39.97
,36.43
,32.52
,29.47
,29.78
,29.92
,29.20
,28.80
,28.65
,29.66
,34.55
,41.22
,43.45
,44.63
,44.98
,45.64
,46.14
,45.91
,45.72
,46.73
,48.44
,48.78
,48.34
,47.06
,43.78
,39.46
,34.90
,31.74
,31.66
,31.54
,30.87
,30.57
,30.26
,31.20
,35.37
,41.79
,44.18
,45.20
,45.71
,46.08
,46.09
,45.84
,45.89
,46.44
,47.52
,48.32
,47.92
,47.05
,44.15
,39.76
,35.21
,32.28
,31.95
,31.65
,31.07
,30.43
,30.03
,31.13
,35.41
,42.27
,44.09
,44.48
,44.12
,43.61
,43.34
,43.06
,43.25
,44.58
,46.91
,48.31
,48.20
,47.40
,44.49
,40.14
,35.24
,32.39
,32.21
,31.63
,30.75
,30.16
,29.76
,30.78
,35.23
,42.02
,44.37
,45.40
,45.11
,45.01
,44.90
,44.83
,44.98
,45.48
,47.59
,48.45
,48.06
,47.34
,44.68
,40.45
,35.71
,31.73
,31.46
,31.80
,31.16
,30.39
,29.81
,30.67
,34.88
,41.13
,42.86
,43.57
,43.43
,43.12
,43.22
,42.91
,42.64
,42.97
,45.34
,47.12
,45.52
,43.43
,40.52
,36.85
,32.94
,29.76
,29.03
,29.13
,28.47
,27.58
,26.85
,26.82
,28.39
,30.28
,33.80
,36.93
,37.98
,38.31
,38.30
,38.59
,38.34
,38.93
,41.60
,43.75
,42.94
,41.00
,38.45
,35.50
,32.61
,30.12
,29.89
,29.59
,28.95
,28.12
,27.48
,27.35
,27.85
,28.51
,31.11
,34.52
,36.77
,37.64
,38.04
,38.12
,37.94
,38.95
,41.86
,43.39
,42.45
,39.93
,37.23
,33.44
,29.50
,26.16
,26.53
,26.86
,26.34
,25.98
,25.57
,26.65
,31.63
,38.07
,40.11
,41.35
,42.21
,42.42
,41.89
,40.73
,40.20
,40.90
,43.61
,46.64
,46.06
,44.21
,40.96
,36.58
,32.17
,28.28
,28.11
,28.56
,27.82
,27.14
,26.80
,27.97
,32.57
,39.17
,40.88
,41.09
,40.09
,39.58
,39.73
,40.33
,41.24
,42.57
,45.57
,47.66
,47.07
,45.68
,42.29
,37.98
,33.54
,29.78
,29.13
,29.49
,29.02
,28.71
,28.48
,29.68
,34.06
,40.14
,41.60
,41.89
,40.85
,40.15
,40.17
,40.62
,41.20
,42.57
,45.71
,48.46
,47.76
,46.14
,43.11
,39.18
,34.85
,31.76
,30.72
,30.32
,29.60
,28.96
,28.73
,30.05
,33.79
,40.22
,42.09
,42.51
,41.87
,41.63
,42.02
,42.18
,42.36
,43.30
,45.89
,47.98
,47.41
,46.23
,43.40
,38.77
,34.05
,31.72
,31.27
,31.18
,30.44
,29.85
,29.32
,30.47
,34.91
,41.09
,42.61
,42.26
,41.52
,40.43
,40.16
,40.29
,40.54
,41.62
,44.52
,47.39
,46.56
,44.91
,42.07
,38.39
,34.42
,31.72
,31.60
,31.20
,30.71
,29.78
,29.23
,29.73
,30.86
,33.65
,37.25
,40.25
,41.49
,42.04
,41.88
,41.19
,40.67
,40.75
,43.03
,46.13
,45.55
,43.11
,40.51
,37.50
,34.22
,31.70
,31.77
,31.50
,30.82
,30.11
,29.56
,29.07
,29.89
,30.82
,32.72
,36.56
,39.10
,40.64
,41.63
,41.51
,41.33
,41.47
,43.22
,44.47
,43.72
,41.63
,38.78
,35.10
,31.40
,28.13
,28.55
,28.62
,28.03
,27.67
,27.33
,28.40
,32.91
,39.80
,41.85
,42.26
,41.56
,41.10
,40.89
,40.83
,41.10
,42.08
,44.88
,46.70
,46.13
,45.01
,42.03
,37.59
,32.92
,28.91
,28.57
,28.59
,28.24
,27.87
,27.18
,28.33
,32.09
,37.95
,39.65
,40.32
,39.93
,39.48
,39.03
,38.69
,38.55
,38.99
,41.56
,44.56
,43.43
,41.91
,39.14
,34.98
,30.68
,26.89
,26.08
,26.10
,25.70
,25.24
,24.49
,25.73
,30.08
,36.41
,38.11
,39.10
,39.67
,38.68
,39.78
,39.54
,39.34
,39.82
,42.29
,45.29
,44.67
,43.16
,40.17
,36.06
,31.81
,28.99
,28.10
,28.31
,27.89
,27.42
,27.01
,28.00
,32.43
,39.08
,40.72
,40.45
,39.44
,38.76
,38.76
,39.26
,40.26
,41.43
,44.69
,47.59
,47.04
,45.96
,43.18
,39.11
,34.53
,31.82
,31.96
,31.45
,30.90
,30.13
,29.69
,30.85
,34.86
,41.28
,43.62
,44.09
,43.30
,42.37
,41.65
,41.12
,41.16
,42.09
,44.38
,47.43
,46.58
,44.54
,41.52
,37.60
,33.47
,30.05
,29.30
,28.83
,28.45
,27.51
,26.49
,26.35
,27.62
,29.05
,32.29
,34.79
,35.58
,36.14
,36.42
,36.05
,35.31
,35.39
,37.41
,40.68
,39.85
,37.23
,34.53
,31.89
,28.85
,26.33
,26.13
,25.53
,25.05
,24.69
,24.57
,24.78
,25.69
,26.90
,28.09
,30.83
,32.11
,32.51
,32.80
,32.81
,32.80
,34.06
,36.98
,40.10
,39.29
,37.18
,34.37
,31.05
,27.60
,25.05
,25.25
,25.62
,25.04
,24.52
,24.18
,24.97
,29.83
,36.44
,38.91
,39.27
,39.34
,39.68
,39.47
,38.96
,38.70
,39.76
,42.56
,46.05
,45.74
,44.64
,41.86
,37.91
,33.48
,30.03
,29.38
,29.39
,29.02
,28.60
,28.46
,29.67
,34.11
,40.55
,42.10
,41.99
,41.04
,39.93
,39.35
,39.48
,40.23
,41.51
,43.77
,46.84
,45.94
,44.32
,41.11
,36.58
,32.00
,27.74
,27.60
,27.71
,27.27
,26.53
,26.02
,27.14
,31.27
,37.79
,39.23
,39.76
,39.41
,38.87
,38.74
,38.01
,38.21
,39.52
,42.72
,46.58
,46.22
,44.53
,41.68
,37.53
,33.11
,29.37
,29.14
,29.23
,28.92
,28.09
,27.66
,28.97
,33.28
,39.14
,40.22
,39.88
,38.30
,37.58
,37.80
,38.15
,39.01
,40.29
,42.51
,46.25
,46.13
,44.36
,41.57
,37.40
,32.89
,29.90
,29.73
,29.49
,28.98
,28.51
,28.25
,29.53
,33.73
,40.42
,42.17
,42.04
,41.36
,40.66
,40.57
,40.69
,41.22
,41.83
,44.01
,47.14
,46.97
,45.10
,42.32
,38.56
,34.92
,31.95
,31.48
,31.41
,30.57
,29.80
,29.01
,29.12
,30.81
,32.80
,36.17
,38.61
,39.30
,39.82
,40.02
,39.59
,39.13
,39.16
,40.86
,43.82
,43.38
,41.40
,38.55
,35.57
,32.74
,30.65
,30.98
,30.36
,29.64
,28.96
,28.41
,28.35
,29.42
,29.79
,31.82
,34.34
,34.93
,35.40
,36.55
,37.34
,37.71
,39.04
,41.77
,45.29
,45.25
,43.74
,41.00
,37.91
,34.05
,30.99
,31.38
,31.49
,31.05
,30.51
,30.12
,31.44
,35.84
,42.47
,44.74
,45.26
,44.49
,44.08
,44.17
,44.29
,44.35
,45.47
,47.01
,48.63
,48.80
,48.25
,45.74
,41.43
,36.37
,32.92
,32.83
,32.95
,32.47
,32.00
,31.53
,32.61
,37.08
,43.62
,44.86
,45.07
,44.41
,44.23
,44.67
,45.11
,44.75
,45.09
,46.76
,47.90
,48.12
,48.14
,45.35
,40.85
,35.97
,32.15
,31.92
,31.97
,31.48
,31.12
,31.18
,32.01
,37.13
,43.58
,45.25
,45.47
,43.87
,42.72
,42.23
,42.08
,42.98
,44.23
,46.14
,48.03
,47.81
,46.81
,45.00
,40.40
,35.61
,32.06
,31.72
,31.61
,30.88
,30.48
,30.11
,30.61
,36.14
,42.31
,43.89
,44.39
,43.89
,43.53
,43.36
,43.23
,43.45
,43.92
,44.18
,45.93
,46.08
,45.07
,42.28
,37.96
,33.43
,30.27
,30.10
,30.28
,29.59
,29.04
,28.80
,29.86
,34.39
,40.06
,41.79
,41.91
,41.23
,40.88
,40.56
,39.71
,39.57
,40.16
,42.58
,46.35
,46.87
,45.05
,42.91
,39.14
,35.16
,31.62
,30.97
,30.79
,30.29
,29.35
,28.15
,28.02
,29.46
,30.77
,34.32
,37.20
,38.13
,38.31
,38.38
,37.93
,37.41
,37.79
,39.28
,41.46
,41.44
,39.60
,36.53
,33.29
,30.08
,27.32
,26.55
,26.54
,26.08
,25.50
,24.96
,25.08
,26.20
,27.35
,28.89
,30.53
,31.26
,31.85
,32.51
,32.43
,33.07
,34.84
,37.72
,41.81
,42.13
,40.83
,38.30
,35.20
,31.54
,29.02
,29.28
,29.36
,29.01
,28.72
,28.63
,29.30
,34.19
,39.60
,42.19
,42.26
,40.71
,39.58
,39.43
,39.70
,40.48
,41.50
,42.89
,46.04
,46.44
,45.09
,42.36
,37.93
,33.37
,30.41
,29.63
,29.67
,28.97
,28.49
,28.09
,29.18
,32.74
,37.94
,41.20
,42.97
,43.51
,43.95
,44.20
,43.78
,43.67
,43.81
,44.77
,46.84
,47.44
,47.15
,45.02
,41.06
,36.25
,32.32
,31.98
,32.18
,31.93
,31.38
,30.61
,31.24
,34.66
,38.53
,40.72
,42.27
,42.76
,43.13
,43.75
,43.74
,43.86
,44.07
,44.81
,46.92
,47.02
,45.38
,42.79
,38.62
,33.83
,30.45
,30.38
,30.44
,30.02
,29.41
,28.86
,29.66
,33.39
,37.44
,38.88
,38.63
,36.81
,35.57
,35.44
,34.83
,35.32
,36.93
,39.82
,44.22
,45.80
,44.78
,42.44
,38.30
,33.92
,30.99
,30.84
,30.81
,30.39
,29.72
,29.19
,30.06
,34.16
,39.03
,40.50
,40.10
,38.78
,37.74
,37.04
,36.76
,37.10
,38.45
,40.06
,43.88
,44.81
,42.87
,40.18
,36.55
,32.71
,29.44
,29.38
,29.60
,28.73
,28.38
,28.00
,27.93
,29.18
,31.58
,34.24
,36.25
,36.01
,35.07
,34.41
,33.59
,33.27
,34.19
,37.20
,41.44
,42.67
,40.71
,37.77
,34.99
,32.21
,29.72
,29.37
,29.61
,29.26
,28.73
,28.25
,28.20
,29.00
,29.60
,31.16
,33.50
,34.77
,35.35
,35.98
,36.24
,36.58
,37.52
,39.55
,42.54
,42.96
,40.94
,38.38
,35.25
,31.75
,29.01
,29.37
,29.63
,29.10
,28.67
,28.31
,29.09
,33.33
,39.04
,41.70
,43.43
,43.79
,43.73
,43.46
,42.83
,42.53
,42.57
,43.63
,45.85
,46.71
,45.37
,42.37
,37.98
,33.30
,29.49
,29.42
,29.30
,28.45
,27.85
,27.44
,28.39
,32.61
,37.77
,39.08
,39.33
,38.58
,37.60
,37.17
,36.65
,36.90
,38.36
,40.68
,44.32
,45.83
,44.62
,42.34
,38.75
,34.08
,30.74
,30.61
,30.44
,29.92
,29.58
,29.40
,30.37
,34.80
,40.07
,42.03
,42.40
,41.74
,41.45
,41.54
,41.27
,41.75
,42.49
,43.98
,46.55
,47.63
,46.27
,44.00
,39.75
,34.97
,31.66
,31.59
,31.69
,30.79
,30.50
,30.15
,31.11
,35.02
,40.34
,42.12
,42.49
,41.65
,41.21
,40.76
,40.14
,39.74
,40.34
,42.54
,46.14
,48.15
,46.75
,44.52
,40.10
,35.21
,32.31
,31.82
,31.82
,31.44
,30.92
,30.93
,31.38
,35.50
,40.69
,41.96
,41.60
,40.33
,39.42
,38.88
,38.45
,38.17
,38.97
,40.65
,44.25
,45.68
,44.30
,41.59
,37.73
,33.86
,31.45
,31.34
,31.31
,30.55
,29.87
,29.12
,29.35
,30.11
,32.23
,34.43
,34.83
,33.40
,32.05
,31.16
,30.38
,30.51
,31.84
,35.21
,39.61
,42.00
,41.04
,38.19
,35.11
,32.15
,29.41
,29.39
,30.10
,29.29
,28.94
,28.38
,28.47
,29.27
,29.39
,30.53
,31.34
,31.23
,30.96
,30.92
,30.85
,31.32
,33.06
,36.70
,41.32
,44.20
,42.69
,40.11
,36.63
,32.74
,29.79
,30.16
,31.01
,30.48
,30.28
,30.11
,30.52
,35.77
,41.11
,42.72
,43.17
,42.71
,43.01
,43.26
,43.52
,43.60
,44.88
,46.71
,48.28
,49.14
,48.44
,47.09
,42.86
,37.57
,33.43
,33.55
,33.74
,33.00
,32.73
,32.61
,35.61
,39.73
,45.21
,46.74
,47.26
,46.08
,45.72
,45.07
,45.10
,45.02
,44.62
,45.88
,48.23
,49.15
,48.59
,47.55
,43.83
,38.60
,34.66
,33.91
,33.78
,33.92
,33.91
,34.53
,35.61
,39.58
,44.37
,45.84
,46.20
,44.60
,44.24
,44.28
,44.40
,44.16
,44.20
,45.54
,48.06
,48.66
,47.20
,45.48
,41.38
,37.54
,34.12
,33.75
,33.66
,32.68
,32.41
,31.98
,33.12
,36.22
,41.74
,43.59
,45.93
,46.64
,47.32
,47.65
,47.13
,46.39
,46.13
,47.25
,48.85
,50.00
,47.41
,44.20
,40.12
,35.70
,33.31
,33.57
,33.68
,33.27
,32.68
,32.38
,33.31
,35.73
,39.70
,43.32
,45.66
,46.41
,46.85
,47.06
,46.18
,45.82
,45.04
,45.57
,47.99
,48.97
,46.46
,43.11
,39.28
,35.74
,33.49
,33.58
,33.39
,32.85
,32.43
,31.88
,32.03
,32.55
,34.11
,37.39
,40.65
,41.36
,41.49
,41.54
,41.10
,40.71
,40.66
,42.23
,44.67
,45.71
,43.79
,41.38
,38.27
,35.13
,33.52
,33.42
,33.10
,32.06
,31.70
,30.92
,30.74
,31.09
,31.37
,32.95
,35.79
,37.66
,38.60
,39.35
,39.38
,39.34
,40.16
,42.02
,44.16
,45.23
,43.76
,41.26
,37.93
,34.40
,31.63
,32.00
,32.34
,31.63
,31.28
,31.29
,32.39
,36.45
,41.48
,42.73
,42.97
,42.54
,42.52
,42.73
,42.85
,43.18
,43.83
,45.81
,47.84
,49.09
,46.99
,43.48
,39.29
,34.54
,30.51
,30.73
,30.99
,30.28
,29.71
,29.35
,30.64
,34.92
,40.09
,41.91
,42.25
,41.52
,40.96
,41.16
,41.21
,41.42
,41.97
,44.13
,46.69
,48.60
,47.37
,44.60
,40.63
,35.84
,31.83
,31.67
,32.02
,31.66
,31.21
,30.86
,32.21
,36.22
,40.98
,41.71
,41.68
,40.70
,39.74
,39.02
,38.61
,38.20
,38.60
,41.39
,44.14
,46.80
,45.86
,43.12
,39.33
,34.78
,31.84
,31.76
,31.38
,30.83
,30.36
,30.00
,31.15
,34.86
,39.14
,39.73
,40.27
,40.10
,39.50
,38.83
,37.56
,36.96
,37.76
,41.03
,43.42
,46.16
,45.48
,43.11
,39.19
,34.54
,31.62
,31.66
,31.54
,30.96
,30.40
,30.19
,31.54
,35.26
,39.96
,41.03
,41.39
,40.94
,40.50
,40.76
,40.86
,40.82
,41.23
,42.43
,43.71
,44.85
,43.67
,40.99
,37.16
,33.24
,30.51
,30.60
,29.79
,28.71
,27.75
,26.95
,27.30
,28.45
,30.01
,33.31
,35.02
,34.82
,34.84
,34.88
,33.99
,33.24
,33.21
,34.19
,36.67
,39.04
,38.55
,36.18
,33.37
,30.95
,29.00
,29.20
,29.11
,28.47
,27.63
,26.89
,26.76
,27.78
,28.38
,30.37
,32.38
,33.10
,33.43
,34.16
,34.01
,33.79
,34.35
,35.66
,37.66
,39.87
,39.32
,37.29
,34.45
,31.04
,28.69
,28.78
,28.71
,27.89
,27.36
,27.06
,28.37
,32.68
,37.94
,39.92
,41.15
,41.36
,41.68
,41.92
,41.65
,41.43
,41.65
,43.46
,45.19
,46.37
,45.11
,42.46
,38.51
,34.01
,30.99
,30.74
,30.62
,29.95
,29.49
,29.09
,30.61
,34.59
,39.66
,40.18
,40.19
,39.11
,38.70
,38.78
,38.06
,37.48
,37.87
,40.52
,43.09
,45.38
,44.93
,42.44
,38.20
,33.51
,30.71
,30.21
,29.74
,29.08
,28.65
,27.83
,28.84
,32.55
,37.03
,37.57
,36.80
,35.35
,34.50
,34.64
,35.00
,35.23
,36.16
,38.54
,40.44
,42.35
,41.78
,38.75
,34.59
,30.07
,27.30
,27.23
,27.03
,26.52
,26.09
,25.86
,27.22
,31.15
,36.29
,38.19
,38.65
,38.48
,38.25
,38.20
,37.91
,37.83
,38.57
,40.29
,41.84
,43.60
,43.03
,40.71
,36.73
,32.30
,28.55
,28.74
,28.75
,27.80
,27.09
,26.67
,27.89
,31.62
,36.58
,37.88
,38.04
,37.12
,36.50
,36.39
,35.43
,35.18
,35.66
,36.70
,38.52
,41.06
,40.55
,37.83
,34.31
,30.77
,27.64
,27.68
,27.91
,26.92
,26.34
,25.73
,25.95
,26.99
,29.54
,33.09
,35.56
,36.02
,36.54
,36.62
,36.33
,36.02
,36.32
,37.63
,39.79
,41.20
,40.49
,38.26
,35.46
,32.39
,29.56
,28.91
,29.38
,28.84
,28.09
,27.40
,27.26
,27.87
,28.75
,31.32
,34.69
,36.93
,38.21
,39.21
,39.43
,39.56
,40.10
,41.11
,42.05
,43.79
,43.02
,40.35
,36.91
,33.01
,29.71
,30.62
,30.82
,30.39
,30.19
,30.01
,30.92
,34.97
,40.14
,41.76
,42.29
,41.70
,41.09
,40.26
,38.93
,38.21
,39.04
,41.97
,45.16
,48.04
,48.22
,45.26
,41.16
,36.10
,32.09
,32.40
,32.98
,32.16
,31.46
,31.23
,32.60
,36.38
,40.93
,41.57
,41.10
,40.90
,40.73
,40.41
,39.93
,39.97
,40.64
,43.13
,45.46
,47.81
,47.89
,45.35
,41.29
,36.51
,32.47
,32.12
,32.80
,32.25
,31.64
,31.36
,32.49
,36.36
,40.05
,39.48
,38.23
,36.42
,36.48
,36.15
,35.45
,35.44
,36.45
,39.36
,42.10
,44.25
,44.34
,41.50
,37.06
,32.00
,28.41
,28.53
,29.02
,28.26
,27.53
,27.58
,29.84
,34.18
,39.76
,40.06
,39.57
,39.21
,39.36
,39.70
,39.58
,38.40
,39.28
,41.75
,43.53
,44.72
,43.59
,40.82
,36.54
,31.78
,27.86
,27.96
,28.17
,26.84
,26.08
,26.13
,26.87
,30.61
,35.19
,35.45
,35.62
,35.84
,34.90
,34.37
,34.23
,34.56
,36.50
,38.20
,40.27
,42.56
,42.34
,40.15
,36.70
,32.87
,29.92
,29.26
,29.57
,28.91
,28.00
,27.30
,27.57
,28.44
,30.90
,33.98
,35.59
,35.44
,35.48
,35.41
,34.95
,34.58
,34.68
,36.04
,38.14
,39.64
,39.47
,37.19
,34.51
,31.53
,29.84
,29.23
,28.96
,27.95
,27.04
,26.64
,27.19
,27.64
,28.76
,29.87
,30.17
,30.18
,30.29
,29.68
,29.22
,29.51
,31.01
,33.35
,35.34
,36.61
,37.05
,34.89
,31.41
,28.52
,26.94
,27.60
,28.16
,27.69
,27.51
,28.85
,33.04
,38.31
,39.22
,38.23
,36.34
,34.76
,34.84
,35.52
,36.01
,36.19
,37.90
,39.50
,40.29
,40.98
,40.47
,37.01
,32.35
,27.98
,26.57
,27.33
,27.79
,27.36
,27.14
,27.77
,31.39
,36.64
,38.80
,39.32
,39.12
,38.60
,38.21
,37.13
,36.29
,36.34
,38.11
,39.15
,39.71
,40.66
,40.19
,37.14
,32.98
,29.74
,28.09
,28.68
,29.22
,28.85
,28.83
,29.89
,33.59
,39.53
,41.18
,41.52
,41.30
,40.99
,40.44
,38.88
,37.75
,37.13
,38.20
,39.65
,40.40
,41.47
,42.00
,39.25
,34.91
,31.85
,29.84
,30.45
,31.29
,31.16
,31.10
,31.86
,35.16
,40.29
,41.38
,40.63
,39.32
,38.73
,38.51
,38.24
,38.54
,38.79
,39.74
,40.59
,40.69
,40.96
,40.20
,37.29
,33.42
,30.72
,28.69
,29.01
,29.16
,28.52
,27.98
,28.27
,29.05
,32.33
,33.95
,34.66
,35.27
,35.27
,35.27
,35.26
,35.36
,35.42
,36.46
,38.00
,38.22
,37.96
,36.83
,34.31
,30.89
,27.82
,26.46
,26.77
,27.10
,26.64
,26.27
,26.30
,27.52
,29.58
,32.16
,33.87
,34.64
,34.79
,34.75
,33.96
,33.52
,33.65
,34.78
,36.00
,36.32
,36.08
,35.82
,34.19
,31.38
,28.55
,27.30
,27.52
,27.93
,27.52
,27.38
,27.22
,27.71
,28.30
,29.83
,31.50
,32.64
,32.98
,33.47
,32.97
,32.72
,33.09
,33.76
,34.45
,34.66
,35.32
,35.43
,33.44
,30.63
,27.58
,25.58
,26.69
,27.09
,26.74
,26.42
,26.53
,27.66
,28.65
,30.27
,32.49
,33.65
,34.04
,34.43
,34.14
,33.99
,34.25
,35.34
,37.06
,37.33
,37.07
,36.54
,33.85
,30.18
,27.62
,26.19
,26.87
,27.24
,26.81
,26.87
,27.34
,30.32
,35.06
,37.63
,38.03
,37.58
,36.83
,36.07
,34.85
,34.04
,34.60
,36.18
,38.10
,39.03
,39.43
,39.57
,36.58
,32.34
,28.41
,27.29
,27.62
,28.01
,27.57
,27.19
,28.31
,31.23
,35.51
,37.79
,37.99
,37.49
,37.31
,37.28
,36.54
,36.12
,36.03
,37.32
,38.62
,38.89
,39.45
,38.98
,35.95
,31.71
,27.46
,26.08
,27.04
,27.48
,27.03
,27.16
,28.57
,32.06
,36.38
,37.59
,36.35
,34.52
,33.09
,32.30
,31.37
,31.21
,31.84
,33.78
,36.35
,37.84
,38.50
,38.98
,36.36
,32.09
,27.98
,26.43
,26.81
,27.23
,26.84
,26.44
,27.34
,29.80
,33.34
,35.44
,35.23
,33.96
,32.50
,31.62
,30.40
,30.31
,30.58
,31.92
,34.29
,35.12
,35.17
,35.39
,33.47
,30.18
,27.47
,26.24
,26.81
,26.84
,26.17
,25.80
,26.14
,26.83
,29.25
,32.55
,34.20
,34.34
,33.94
,33.14
,32.02
,31.26
,31.18
,32.65
,34.63
,35.05
,35.10
,35.04
,33.40
,30.74
,27.64
,26.51
,26.52
,26.38
,25.90
,25.26
,25.36
,26.23
,27.30
,29.21
,31.50
,32.59
,33.28
,33.39
,33.02
,32.62
,32.78
,33.81
,35.00
,35.35
,35.49
,36.04
,34.21
,31.12
,28.02
,26.48
,27.01
,27.35
,26.88
,26.61
,27.97
,31.20
,36.14
,39.07
,39.68
,39.31
,38.80
,38.44
,38.01
,38.42
,38.65
,39.31
,40.37
,40.48
,40.39
,39.40
,36.22
,31.79
,28.38
,26.52
,27.00
,27.02
,26.34
,26.19
,27.34
,30.30
,34.72
,37.57
,38.57
,38.63
,38.54
,38.41
,37.99
,37.64
,37.81
,38.76
,39.34
,39.65
,39.47
,39.19
,36.51
,32.39
,28.87
,27.10
,27.44
,27.63
,26.97
,26.94
,27.88
,30.60
,35.39
,38.26
,39.16
,39.30
,39.39
,39.32
,38.91
,38.53
,38.55
,39.16
,40.14
,40.37
,40.00
,39.55
,37.04
,33.38
,29.56
,27.48
,27.61
,28.11
,27.75
,27.57
,28.51
,30.94
,35.74
,38.25
,38.79
,38.72
,38.75
,38.62
,38.44
,38.67
,39.17
,40.11
,40.62
,40.87
,40.41
,39.95
,37.29
,33.16
,30.00
,28.29
,28.52
,28.96
,28.52
,28.26
,29.28
,31.93
,36.73
,39.46
,40.42
,40.62
,40.57
,40.01
,39.36
,39.04
,38.74
,39.14
,39.79
,39.90
,39.68
,39.24
,36.86
,32.93
,29.70
,28.01
,27.99
,28.02
,27.50
,26.96
,26.56
,27.54
,29.26
,30.71
,32.09
,30.91
,30.14
,28.50
,26.83
,25.81
,25.85
,27.45
,29.98
,31.95
,32.55
,33.33
,31.80
,29.22
,26.48
,25.33
,25.47
,25.38
,24.58
,24.13
,24.21
,24.59
,25.04
,27.18
,29.13
,29.62
,29.52
,29.82
,29.62
,29.40
,30.04
,31.69
,32.88
,33.15
,33.29
,33.62
,31.81
,28.69
,24.99
,24.02
,24.64
,24.84
,24.34
,24.25
,25.65
,29.02
,33.82
,34.50
,33.53
,32.83
,32.73
,32.36
,31.32
,30.56
,30.35
,32.40
,34.29
,35.13
,35.47
,35.71
,33.24
,28.65
,24.45
,23.44
,23.96
,23.82
,23.29
,22.97
,24.05
,27.07
,32.27
,33.51
,33.46
,32.52
,31.73
,32.11
,31.28
,30.99
,31.62
,33.82
,35.36
,35.44
,35.38
,35.36
,33.09
,28.81
,25.44
,24.06
,24.42
,24.35
,23.90
,23.77
,24.85
,28.38
,33.05
,33.10
,32.55
,30.83
,29.51
,28.87
,28.14
,27.60
,28.00
,30.15
,32.16
,33.42
,33.91
,34.66
,33.12
,29.20
,25.91
,24.45
,24.18
,23.64
,22.91
,23.32
,25.16
,28.43
,33.20
,33.56
,32.82
,31.72
,30.91
,30.46
,30.01
,29.94
,30.47
,32.50
,34.31
,35.39
,35.63
,36.22
,34.91
,31.26
,27.27
,25.65
,25.16
,24.62
,24.13
,24.16
,25.20
,28.23
,33.05
,34.05
,33.12
,31.84
,30.21
,28.85
,27.71
,27.34
,26.75
,29.63
,31.61
,32.78
,33.35
,34.06
,32.90
,29.89
,26.45
,25.16
,24.90
,24.11
,23.48
,23.28
,23.49
,24.32
,26.07
,28.01
,28.32
,27.57
,26.63
,25.54
,24.45
,23.98
,24.69
,26.42
,28.33
,29.31
,29.75
,30.21
,29.53
,26.94
,23.90
,22.15
,21.94
,22.02
,21.01
,20.58
,20.84
,21.48
,22.27
,23.65
,24.95
,25.26
,25.26
,25.34
,24.89
,24.51
,24.91
,26.38
,27.89
,28.80
,29.58
,30.29
,29.49
,26.20
,22.64
,21.48
,21.62
,21.50
,21.23
,21.30
,22.42
,25.57
,30.34
,31.97
,31.88
,31.50
,30.67
,30.14
,29.31
,29.13
,29.25
,31.36
,33.23
,33.66
,33.38
,33.27
,31.49
,27.42
,23.41
,22.39
,22.57
,22.62
,22.33
,22.48
,23.85
,27.48
,32.39
,34.46
,34.74
,34.19
,34.48
,34.98
,35.12
,35.41
,36.07
,37.18
,37.94
,37.90
,36.98
,36.18
,34.08
,29.59
,25.70
,24.13
,24.10
,23.99
,23.46
,23.58
,24.69
,27.96
,32.45
,32.30
,31.56
,31.17
,30.74
,30.07
,29.42
,28.96
,29.10
,31.62
,32.73
,33.45
,33.61
,33.93
,32.79
,28.87
,24.81
,23.23
,23.17
,23.32
,23.09
,23.08
,24.06
,27.02
,31.49
,31.48
,30.78
,29.97
,30.05
,29.57
,28.62
,28.12
,28.66
,30.71
,32.83
,34.22
,35.14
,35.62
,34.86
,31.36
,27.36
,25.84
,25.74
,25.63
,25.31
,25.42
,26.44
,29.73
,35.45
,37.77
,38.45
,38.20
,37.99
,37.68
,37.46
,36.85
,36.50
,37.37
,37.67
,37.40
,36.66
,36.15
,34.68
,31.20
,27.48
,26.11
,25.83
,25.61
,24.90
,24.64
,24.85
,25.40
,28.24
,31.26
,32.82
,33.31
,33.04
,32.88
,32.01
,31.24
,31.14
,31.88
,33.34
,33.95
,33.75
,33.31
,32.68
,29.93
,26.76
,25.56
,25.51
,25.18
,24.50
,23.90
,23.66
,23.77
,25.43
,27.38
,29.46
,30.75
,31.39
,31.61
,31.51
,31.31
,31.58
,32.58
,33.79
,34.02
,33.83
,33.41
,32.38
,29.01
,25.10
,24.20
,24.37
,24.53
,24.09
,24.35
,25.43
,28.81
,34.93
,36.79
,36.77
,36.33
,35.77
,35.18
,34.55
,34.05
,34.14
,35.60
,36.57
,37.05
,36.99
,36.73
,36.06
,31.95
,27.40
,26.22
,26.44
,26.40
,26.17
,26.44
,27.24
,30.28
,34.27
,34.43
,32.93
,31.11
,30.19
,30.79
,30.28
,29.88
,30.29
,32.45
,34.13
,34.98
,35.16
,34.84
,33.24
,29.26
,25.69
,23.82
,23.71
,23.83
,23.27
,23.21
,24.38
,28.30
,33.97
,35.64
,36.03
,35.59
,34.79
,34.06
,32.64
,31.46
,31.16
,32.34
,33.60
,34.39
,34.79
,34.76
,34.13
,30.92
,27.70
,25.17
,25.25
,25.17
,24.86
,24.97
,26.10
,30.05
,34.06
,34.37
,33.38
,31.89
,31.49
,31.39
,30.71
,30.15
,30.48
,32.87
,34.68
,35.53
,35.52
,35.40
,34.26
,30.42
,26.99
,25.45
,25.34
,25.29
,24.69
,24.72
,25.53
,28.90
,33.36
,34.06
,33.41
,32.74
,32.62
,32.32
,31.54
,31.13
,30.55
,31.69
,32.68
,33.27
,33.23
,32.88
,32.49
,29.84
,26.36
,24.61
,24.50
,24.21
,23.49
,23.17
,23.13
,24.01
,25.19
,26.48
,26.23
,24.92
,23.56
,22.79
,21.74
,21.10
,21.63
,23.61
,26.45
,28.05
,28.45
,28.64
,29.34
,27.69
,24.83
,22.74
,22.29
,22.40
,22.11
,21.85
,21.62
,22.06
,22.33
,23.24
,23.70
,23.19
,22.33
,21.85
,21.17
,20.50
,21.07
,22.56
,24.58
,26.37
,27.43
,27.94
,28.72
,27.12
,24.12
,22.37
,22.22
,22.08
,22.07
,22.05
,22.09
,23.05
,24.33
,25.04
,25.66
,25.20
,24.31
,23.68
,22.90
,22.65
,23.21
,24.92
,27.30
,28.97
,29.81
,30.02
,30.22
,27.92
,24.83
,23.66
,23.02
,22.50
,22.22
,22.26
,22.69
,26.00
,30.70
,31.73
,31.45
,30.35
,29.45
,29.34
,29.06
,29.28
,30.01
,31.80
,33.01
,33.43
,33.44
,33.07
,32.69
,29.45
,26.05
,24.27
,23.57
,23.13
,22.87
,22.98
,23.64
,26.69
,30.85
,31.29
,30.17
,29.16
,29.06
,28.99
,28.75
,28.91
,30.14
,32.31
,33.66
,34.02
,33.69
,33.24
,32.29
,28.74
,25.76
,23.88
,23.21
,22.84
,22.37
,22.53
,23.12
,26.53
,30.70
,30.83
,29.78
,28.80
,28.41
,28.04
,27.81
,27.56
,28.10
,30.00
,32.02
,33.11
,33.49
,33.30
,32.79
,29.81
,26.35
,24.36
,23.40
,22.66
,22.25
,22.04
,22.85
,25.55
,29.88
,30.38
,29.11
,27.96
,28.01
,28.44
,28.16
,28.24
,28.34
,30.36
,31.61
,32.06
,31.96
,31.33
,30.76
,28.60
,26.04
,24.18
,23.55
,23.17
,22.91
,22.81
,22.45
,23.41
,25.60
,27.45
,28.49
,28.43
,28.13
,27.81
,27.51
,27.26
,27.81
,29.15
,30.73
,31.44
,31.41
,31.17
,30.77
,28.44
,25.57
,23.87
,23.06
,22.52
,22.23
,22.06
,21.73
,22.23
,23.05
,24.29
,25.39
,25.73
,25.80
,25.63
,24.89
,24.18
,24.04
,25.00
,27.26
,28.81
,29.62
,29.73
,29.89
,27.93
,24.26
,22.88
,22.55
,22.09
,21.76
,21.87
,22.83
,26.51
,30.94
,31.21
,30.21
,28.85
,28.16
,27.81
,27.50
,27.48
,27.86
,29.70
,31.40
,32.48
,32.86
,32.52
,32.49
,29.54
,26.37
,24.52
,23.78
,23.36
,23.00
,22.98
,23.71
,27.17
,31.46
,31.83
,30.95
,30.01
,29.22
,28.49
,27.95
,27.88
,28.78
,30.49
,32.01
,32.86
,33.25
,32.87
,32.05
,28.85
,25.83
,23.58
,22.76
,22.16
,21.62
,21.36
,22.18
,25.38
,30.61
,32.67
,32.88
,32.64
,32.48
,32.51
,31.88
,31.48
,31.58
,33.05
,34.17
,34.05
,33.65
,33.26
,32.88
,29.73
,26.32
,24.28
,23.56
,23.40
,23.07
,22.89
,23.47
,26.86
,31.55
,31.85
,31.24
,29.94
,29.27
,28.99
,28.46
,28.40
,29.01
,30.95
,32.66
,33.54
,33.68
,33.46
,33.25
,30.70
,27.29
,25.29
,24.45
,24.16
,23.79
,23.69
,24.34
,27.47
,31.53
,32.34
,31.60
,30.51
,29.75
,29.25
,28.55
,28.24
,28.62
,30.37
,31.77
,32.36
,32.34
,32.01
,31.78
,30.04
,26.77
,25.00
,24.03
,23.50
,22.93
,22.56
,22.20
,23.45
,24.83
,25.92
,26.00
,25.50
,24.10
,22.63
,22.08
,21.54
,21.56
,23.44
,25.33
,26.95
,27.58
,27.56
,27.81
,26.65
,23.94
,22.09
,21.67
,21.26
,20.65
,20.30
,19.90
,20.66
,21.54
,22.18
,22.58
,22.38
,22.17
,21.90
,21.20
,20.90
,21.59
,23.63
,25.90
,27.93
,28.82
,28.91
,28.77
,27.05
,24.57
,23.01
,22.57
,22.33
,22.19
,22.31
,23.10
,26.25
,30.20
,30.59
,30.34
,29.75
,29.39
,29.63
,29.13
,29.15
,29.89
,31.61
,32.84
,33.05
,32.88
,32.45
,31.61
,28.83
,25.96
,23.81
,22.89
,22.42
,21.77
,21.37
,22.03
,25.13
,29.36
,29.80
,29.18
,28.14
,27.24
,27.55
,26.93
,26.68
,27.36
,29.05
,30.74
,31.64
,32.00
,31.52
,31.01
,28.33
,25.24
,23.16
,22.63
,22.16
,21.90
,21.88
,22.62
,25.89
,30.45
,31.36
,30.80
,29.71
,28.75
,28.19
,27.28
,27.06
,27.66
,29.84
,31.63
,32.16
,32.05
,31.80
,31.48
,29.07
,25.74
,23.67
,22.87
,22.49
,21.90
,21.98
,22.75
,26.08
,31.06
,32.83
,33.11
,32.16
,31.81
,31.35
,30.89
,30.84
,31.26
,32.64
,33.88
,33.91
,33.71
,33.11
,32.28
,29.55
,26.83
,24.61
,23.57
,23.08
,22.60
,22.46
,23.14
,26.07
,30.85
,33.11
,33.50
,33.25
,32.86
,32.57
,31.64
,31.17
,31.09
,31.98
,32.59
,32.40
,31.76
,31.18
,30.44
,27.95
,25.30
,23.25
,22.34
,21.60
,21.11
,20.66
,20.54
,21.65
,23.46
,25.82
,26.44
,25.81
,25.21
,24.33
,22.88
,21.61
,21.47
,22.53
,24.77
,26.06
,26.45
,26.06
,26.01
,25.19
,22.52
,20.78
,20.92
,20.74
,20.77
,20.85
,20.90
,20.90
,20.80
,21.63
,23.06
,23.40
,23.30
,23.30
,22.78
,22.27
,22.57
,23.88
,25.99
,27.43
,28.06
,27.95
,27.64
,26.57
,23.82
,22.30
,22.07
,21.77
,21.34
,21.11
,20.90
,22.08
,23.84
,25.76
,26.77
,26.74
,26.42
,25.91
,25.35
,24.83
,25.25
,26.27
,27.83
,29.01
,29.31
,29.39
,29.40
,27.84
,24.50
,23.14
,22.32
,21.83
,21.36
,21.20
,21.83
,24.37
,28.45
,31.25
,31.71
,31.29
,30.58
,31.23
,31.14
,31.11
,31.79
,32.58
,33.67
,34.00
,33.45
,32.42
,31.49
,28.75
,25.48
,23.41
,22.78
,22.28
,21.98
,21.77
,22.32
,25.05
,30.69
,33.51
,33.78
,34.19
,33.96
,34.24
,34.14
,34.35
,34.05
,34.75
,35.21
,34.84
,34.10
,33.29
,32.50
,30.03
,26.99
,24.88
,23.91
,23.78
,23.26
,23.23
,23.78
,26.11
,30.65
,33.66
,33.81
,33.62
,33.31
,33.08
,32.76
,32.71
,33.03
,33.75
,34.36
,34.26
,34.48
,33.85
,32.68
,30.36
,27.65
,25.64
,24.89
,24.20
,23.78
,23.47
,23.59
,25.85
,30.38
,32.66
,33.14
,32.46
,32.30
,32.09
,31.49
,31.13
,30.96
,31.68
,32.60
,32.68
,32.17
,31.28
,30.68
,29.31
,27.10
,24.88
,23.63
,22.83
,22.31
,22.02
,21.79
,22.85
,24.41
,26.92
,27.93
,27.94
,27.70
,27.02
,25.96
,25.06
,24.94
,26.18
,28.05
,28.80
,29.21
,28.81
,28.65
,27.79
,25.12
,23.29
,22.53
,21.98
,21.62
,21.05
,20.66
,21.26
,21.76
,22.83
,24.12
,24.66
,24.89
,24.94
,24.38
,23.80
,23.96
,25.49
,27.37
,28.57
,29.13
,29.02
,28.75
,27.66
,24.47
,23.31
,22.83
,22.27
,21.87
,21.71
,22.96
,25.53
,30.16
,32.28
,32.71
,32.62
,32.46
,32.31
,31.74
,31.57
,31.80
,32.93
,34.37
,34.40
,33.81
,32.78
,31.48
,28.62
,25.67
,23.78
,23.17
,22.67
,22.32
,22.50
,23.51
,26.08
,31.16
,33.08
,33.65
,33.22
,33.03
,32.51
,31.32
,30.60
,30.40
,31.58
,32.67
,33.07
,32.96
,32.40
,31.42
,29.26
,26.19
,24.29
,23.50
,22.99
,22.44
,22.19
,22.83
,25.93
,30.12
,30.99
,31.04
,30.00
,29.37
,28.87
,28.52
,28.66
,29.18
,30.93
,32.38
,33.02
,33.17
,32.68
,31.80
,29.61
,26.57
,24.59
,23.65
,23.06
,22.71
,22.45
,23.28
,26.17
,30.42
,31.74
,31.72
,30.97
,30.80
,30.65
,30.50
,30.70
,31.19
,32.39
,33.36
,33.57
,33.52
,32.87
,31.85
,29.71
,26.03
,24.25
,24.07
,23.16
,22.49
,22.20
,23.03
,26.14
,30.93
,32.27
,32.65
,32.45
,32.57
,32.15
,31.38
,30.91
,30.97
,32.03
,32.76
,32.85
,32.38
,31.43
,30.66
,28.83
,26.21
,24.25
,23.24
,22.78
,22.37
,21.89
,21.55
,22.53
,24.23
,26.96
,27.99
,27.83
,26.96
,26.12
,25.08
,24.36
,24.50
,25.97
,28.07
,29.16
,28.91
,28.25
,27.71
,27.08
,24.60
,22.56
,22.01
,22.04
,21.58
,21.21
,21.02
,21.61
,22.64
,23.43
,24.92
,25.48
,25.33
,24.90
,23.59
,22.89
,23.24
,24.85
,27.12
,28.46
,28.90
,28.47
,28.05
,27.24
,24.14
,23.03
,22.68
,22.38
,22.29
,22.05
,23.13
,25.25
,29.60
,30.92
,30.56
,29.73
,29.17
,29.05
,28.74
,28.55
,29.07
,30.64
,31.99
,32.49
,32.51
,31.98
,31.10
,28.97
,25.40
,23.69
,23.44
,23.18
,22.67
,22.47
,23.17
,25.94
,30.30
,32.16
,32.52
,32.02
,31.83
,31.74
,31.41
,31.31
,31.69
,32.75
,33.53
,33.71
,33.67
,32.94
,31.61
,29.50
,25.90
,23.72
,23.13
,22.75
,22.38
,22.12
,22.64
,25.89
,30.13
,31.03
,30.59
,29.77
,29.69
,29.85
,29.53
,29.57
,29.89
,31.06
,32.06
,31.88
,31.09
,30.13
,28.84
,26.39
,23.16
,21.52
,21.32
,21.14
,20.81
,21.15
,20.97
,23.39
,27.35
,28.99
,29.52
,28.97
,28.34
,27.19
,26.37
,25.52
,26.00
,28.02
,29.36
,30.37
,30.96
,30.31
,29.41
,28.61
,25.65
,23.75
,22.78
,22.34
,22.01
,21.87
,22.27
,24.98
,28.73
,30.03
,29.99
,29.66
,29.32
,29.38
,29.26
,29.03
,29.17
,30.18
,31.08
,31.32
,30.83
,30.16
,29.62
,28.54
,25.61
,23.79
,23.20
,22.61
,22.13
,21.83
,21.55
,22.51
,23.92
,26.31
,27.08
,27.21
,26.67
,26.25
,25.37
,24.33
,23.95
,24.65
,25.89
,26.52
,26.58
,26.25
,26.37
,25.94
,23.74
,21.80
,20.71
,20.48
,20.15
,19.87
,19.62
,20.27
,21.34
,22.73
,24.31
,25.32
,25.99
,26.37
,25.95
,25.72
,26.24
,27.41
,28.11
,28.73
,28.81
,28.23
,27.34
,25.71
,22.67
,21.39
,20.91
,20.63
,20.52
,20.41
,21.17
,24.02
,28.55
,30.01
,29.68
,28.54
,27.78
,27.68
,27.35
,27.61
,28.75
,30.68
,31.98
,32.51
,31.55
,30.07
,29.24
,27.25
,23.80
,22.02
,22.27
,21.90
,21.58
,21.11
,21.57
,25.49
,30.49
,32.38
,32.72
,32.21
,31.66
,31.40
,31.67
,31.56
,31.71
,32.44
,33.40
,33.54
,33.32
,32.17
,30.87
,28.61
,25.11
,23.16
,22.57
,21.81
,21.57
,21.26
,21.84
,24.91
,29.25
,30.80
,31.14
,31.08
,30.94
,31.07
,30.93
,30.84
,30.98
,31.87
,32.25
,32.30
,31.90
,31.09
,30.14
,27.97
,24.17
,21.97
,21.86
,21.64
,21.48
,21.38
,22.12
,24.28
,27.53
,28.37
,28.12
,27.40
,26.99
,27.05
,26.66
,26.32
,26.65
,28.48
,29.95
,30.84
,31.09
,30.31
,29.61
,28.26
,25.02
,23.31
,22.36
,21.70
,21.52
,21.54
,22.18
,25.01
,28.87
,29.95
,29.29
,28.35
,28.04
,27.70
,27.06
,26.40
,26.48
,28.02
,29.56
,30.26
,30.39
,29.61
,29.11
,28.37
,25.54
,23.49
,22.49
,22.09
,21.71
,21.18
,21.10
,22.04
,23.14
,24.76
,25.48
,25.10
,24.33
,23.52
,22.71
,22.38
,23.02
,24.64
,26.54
,27.72
,27.87
,27.62
,27.57
,26.95
,24.44
,22.42
,22.18
,21.50
,21.17
,20.57
,20.22
,20.87
,21.23
,22.02
,23.08
,23.34
,23.07
,22.90
,22.01
,21.54
,22.12
,23.59
,25.78
,27.39
,28.38
,28.21
,27.90
,27.38
,24.47
,23.06
,22.71
,22.42
,22.17
,21.80
,22.69
,25.63
,29.40
,30.45
,30.22
,29.64
,29.47
,29.22
,28.80
,28.80
,29.52
,31.31
,32.62
,33.29
,33.37
,32.61
,32.01
,30.25
,26.82
,25.22
,24.49
,23.86
,23.61
,23.55
,24.17
,26.68
,30.32
,31.08
,30.79
,30.03
,29.71
,29.59
,29.24
,29.28
,29.94
,31.32
,32.69
,33.12
,33.03
,32.45
,31.54
,29.80
,26.56
,24.99
,24.48
,24.05
,23.75
,23.45
,23.96
,26.36
,30.55
,31.59
,30.87
,29.51
,29.03
,28.90
,28.67
,28.71
,29.16
,30.67
,32.16
,32.87
,33.17
,32.57
,31.26
,29.58
,26.39
,24.95
,24.20
,23.53
,23.41
,23.11
,23.59
,26.07
,30.25
,31.53
,30.88
,29.84
,29.39
,29.40
,29.17
,29.40
,29.87
,31.43
,32.42
,32.87
,32.70
,31.76
,31.01
,29.62
,26.23
,24.38
,24.12
,23.55
,23.17
,22.89
,23.43
,25.58
,29.50
,30.45
,30.12
,29.46
,28.94
,28.73
,28.12
,27.78
,28.08
,29.16
,30.28
,30.74
,31.01
,30.36
,29.47
,28.39
,25.52
,23.99
,23.24
,22.37
,22.08
,21.52
,21.37
,22.10
,23.21
,24.80
,24.85
,24.56
,23.64
,22.81
,22.33
,22.00
,22.10
,23.49
,25.43
,26.54
,27.13
,26.83
,27.28
,26.89
,24.38
,22.20
,21.45
,21.27
,21.06
,20.40
,20.30
,20.85
,21.42
,22.13
,23.31
,23.67
,23.85
,24.17
,24.08
,23.88
,24.44
,25.67
,27.15
,28.54
,29.06
,28.93
,28.45
,27.74
,24.69
,22.48
,21.63
,21.30
,21.52
,21.32
,21.74
,24.98
,29.06
,30.34
,30.11
,29.62
,28.99
,28.76
,28.78
,28.97
,29.72
,30.77
,32.05
,32.58
,32.89
,31.84
,30.88
,29.41
,26.07
,23.48
,22.81
,22.50
,22.72
,22.45
,21.97
,25.48
,29.23
,30.21
,30.22
,29.50
,29.30
,29.20
,28.91
,29.09
,29.66
,31.08
,32.31
,32.83
,32.01
,30.84
,30.22
,29.85
,26.44
,24.45
,24.16
,23.40
,23.16
,23.06
,23.47
,25.74
,30.06
,31.98
,32.00
,31.68
,31.34
,31.36
,31.28
,31.19
,31.44
,32.25
,33.29
,33.55
,33.11
,32.42
,32.00
,30.04
,26.54
,24.01
,23.21
,22.24
,21.91
,21.70
,22.34
,25.96
,30.13
,31.54
,31.65
,31.21
,31.17
,31.04
,30.79
,30.66
,31.04
,32.54
,33.24
,33.21
,33.05
,32.70
,32.14
,30.67
,27.20
,25.63
,24.79
,24.45
,24.19
,23.95
,24.29
,26.48
,30.09
,31.47
,31.35
,30.68
,30.03
,29.54
,29.15
,29.36
,29.94
,30.93
,32.08
,32.57
,32.45
,31.64
,30.84
,29.72
,26.88
,24.82
,23.79
,23.47
,22.96
,23.03
,22.85
,23.35
,24.81
,26.39
,26.81
,26.42
,25.77
,25.34
,24.69
,24.44
,24.68
,25.36
,27.70
,28.49
,28.82
,28.49
,28.18
,27.84
,25.60
,23.44
,22.32
,21.74
,21.89
,21.81
,21.45
,22.01
,22.23
,23.02
,23.90
,24.14
,24.20
,24.54
,24.03
,23.63
,23.97
,25.03
,26.80
,28.38
,29.07
,29.12
,28.85
,28.25
,25.56
,23.84
,23.17
,23.03
,22.82
,22.73
,23.29
,25.96
,30.24
,31.83
,31.90
,31.69
,31.73
,32.20
,31.87
,31.58
,31.73
,32.75
,33.68
,33.66
,33.30
,32.48
,31.33
,29.62
,26.25
,24.63
,24.25
,23.62
,23.41
,23.48
,23.93
,26.34
,30.37
,31.91
,31.94
,31.40
,31.22
,30.94
,30.20
,29.73
,30.09
,31.66
,32.85
,33.43
,33.30
,32.13
,31.27
,29.52
,26.37
,24.16
,23.65
,23.29
,23.30
,23.32
,23.44
,26.52
,30.76
,32.20
,32.42
,31.95
,31.79
,31.72
,31.41
,31.31
,31.51
,32.55
,33.45
,33.58
,31.91
,30.47
,29.98
,30.11
,26.61
,24.46
,23.82
,23.41
,23.16
,23.39
,23.62
,26.42
,30.90
,32.41
,32.65
,32.06
,31.32
,30.79
,30.86
,30.57
,30.86
,32.31
,33.11
,33.03
,32.94
,32.51
,31.81
,30.13
,26.71
,24.62
,24.20
,23.84
,23.61
,23.55
,23.92
,26.47
,30.76
,32.75
,32.79
,32.11
,31.62
,31.05
,30.60
,30.60
,30.74
,31.53
,32.59
,32.56
,32.06
,31.35
,30.56
,29.46
,26.54
,24.53
,23.36
,22.84
,22.96
,22.54
,22.13
,23.06
,23.88
,25.65
,26.27
,25.95
,25.55
,24.96
,24.20
,23.63
,24.27
,25.01
,26.81
,27.91
,28.31
,28.11
,28.00
,27.35
,24.86
,22.85
,22.62
,21.80
,21.46
,21.25
,20.66
,21.26
,21.91
,22.41
,23.36
,23.60
,23.50
,23.35
,22.91
,22.55
,23.27
,24.73
,26.59
,28.26
,29.13
,29.05
,28.79
,27.91
,24.95
,23.33
,22.91
,22.44
,22.34
,22.30
,22.73
,25.62
,30.04
,31.98
,32.59
,32.10
,32.10
,32.14
,32.18
,31.93
,31.87
,33.04
,33.96
,33.57
,33.08
,32.64
,31.63
,29.77
,26.22
,24.37
,23.74
,23.57
,23.26
,23.51
,23.78
,26.26
,29.99
,31.46
,31.82
,31.69
,32.04
,32.27
,31.78
,31.39
,31.53
,32.91
,33.55
,33.37
,32.97
,32.14
,31.53
,29.62
,26.10
,24.24
,23.84
,23.68
,23.42
,23.55
,23.56
,26.33
,30.54
,32.19
,32.21
,31.97
,32.31
,32.31
,31.97
,31.98
,32.29
,33.44
,34.13
,33.94
,33.29
,32.56
,31.89
,29.87
,26.42
,24.78
,24.02
,23.35
,23.59
,23.55
,23.92
,26.21
,30.33
,31.93
,31.68
,31.06
,30.85
,30.89
,30.53
,30.44
,30.85
,31.90
,32.72
,32.88
,32.79
,32.06
,31.32
,29.53
,25.99
,24.34
,23.84
,23.35
,23.00
,23.13
,23.49
,25.61
,29.82
,31.44
,31.69
,31.62
,31.44
,31.37
,30.99
,30.95
,31.20
,32.13
,33.20
,32.91
,32.18
,31.21
,30.44
,28.78
,25.69
,23.53
,22.77
,22.60
,22.21
,22.08
,22.20
,22.71
,24.24
,26.18
,26.90
,26.87
,26.39
,26.00
,25.43
,25.02
,25.21
,26.31
,27.79
,28.24
,28.03
,27.53
,27.42
,26.64
,24.41
,22.29
,20.80
,20.73
,20.92
,20.85
,20.68
,21.08
,21.64
,22.92
,24.29
,24.60
,24.66
,24.73
,23.97
,23.48
,23.90
,25.44
,27.19
,28.34
,28.95
,28.98
,28.77
,27.89
,24.90
,22.88
,22.04
,22.09
,22.01
,22.15
,21.95
,25.25
,29.33
,31.65
,32.41
,31.89
,31.64
,31.51
,31.39
,31.28
,31.87
,32.77
,33.77
,33.89
,33.69
,32.94
,32.09
,30.04
,26.49
,24.60
,24.21
,23.73
,23.52
,23.47
,23.44
,26.01
,29.73
,31.96
,32.31
,31.88
,31.54
,31.33
,31.24
,31.45
,31.76
,32.42
,33.47
,33.78
,33.32
,32.58
,32.16
,30.39
,26.90
,24.35
,23.89
,23.36
,23.00
,23.01
,22.47
,25.55
,29.29
,31.07
,31.47
,30.66
,30.15
,29.90
,29.49
,29.37
,29.94
,31.08
,32.59
,32.97
,32.64
,32.00
,31.72
,30.14
,26.72
,24.41
,24.00
,23.54
,23.14
,23.22
,23.18
,25.44
,29.06
,30.96
,31.27
,30.73
,30.78
,30.80
,30.84
,30.72
,31.35
,31.86
,32.99
,33.26
,33.08
,32.32
,32.04
,30.25
,26.83
,25.33
,24.59
,23.85
,23.51
,23.78
,24.38
,25.99
,29.39
,31.41
,31.79
,31.66
,31.35
,31.47
,30.98
,30.94
,31.56
,32.55
,33.47
,33.17
,32.17
,31.15
,30.47
,28.28
,24.92
,22.79
,22.42
,21.85
,21.59
,21.62
,21.37
,21.80
,22.23
,23.33
,23.35
,22.84
,21.93
,20.95
,20.18
,20.70
,21.16
,22.17
,23.30
,23.63
,23.80
,23.68
,24.14
,23.31
,21.44
,19.72
,19.49
,19.08
,18.97
,19.04
,18.95
,19.45
,20.48
,21.41
,23.33
,25.07
,26.04
,26.20
,25.81
,25.57
,25.57
,26.27
,27.18
,27.39
,27.14
,26.91
,27.09
,25.69
,23.24
,21.47
,21.14
,21.04
,20.67
,20.44
,21.38
,24.16
,27.58
,30.28
,31.05
,30.75
,30.75
,30.62
,29.80
,29.41
,29.65
,30.50
,31.78
,31.93
,31.64
,31.14
,30.46
,28.02
,24.89
,23.51
,22.77
,22.33
,22.15
,22.02
,22.86
,24.68
,27.61
,28.88
,28.19
,27.04
,26.24
,26.72
,26.29
,26.17
,26.80
,28.43
,30.04
,30.69
,30.28
,29.84
,29.57
,27.17
,23.83
,21.89
,21.52
,21.13
,21.04
,21.09
,21.57
,23.98
,27.11
,29.17
,29.35
,28.80
,28.29
,28.12
,27.85
,27.80
,28.17
,29.36
,30.64
,31.31
,31.34
,30.57
,30.07
,27.47
,23.88
,22.30
,21.69
,21.47
,21.31
,21.42
,21.90
,24.29
,27.87
,30.01
,30.43
,29.94
,29.92
,29.84
,29.72
,29.88
,30.33
,31.45
,32.75
,33.36
,33.32
,32.56
,32.31
,29.79
,26.22
,24.78
,24.03
,23.59
,23.36
,23.22
,22.94
,25.41
,29.12
,31.74
,32.43
,31.97
,31.77
,31.99
,31.28
,31.01
,31.79
,31.97
,32.82
,32.99
,32.30
,31.36
,30.96
,28.81
,25.84
,23.65
,23.03
,22.72
,22.67
,22.50
,22.02
,22.24
,23.84
,25.86
,26.50
,26.12
,25.42
,24.79
,23.78
,23.11
,23.30
,24.36
,26.52
,27.60
,27.96
,27.80
,28.21
,26.93
,24.49
,22.65
,21.86
,21.53
,21.63
,21.47
,21.19
,21.43
,21.38
,22.52
,23.21
,23.17
,23.10
,22.97
,22.49
,22.26
,22.70
,24.27
,26.27
,27.69
,28.34
,28.27
,28.69
,27.08
,24.12
,22.50
,21.84
,21.53
,21.33
,21.39
,21.41
,24.47
,28.16
,30.41
,30.88
,30.06
,29.27
,29.00
,28.48
,28.41
,29.41
,30.28
,32.31
,33.73
,33.03
,32.52
,32.49
,30.01
,26.44
,24.62
,24.22
,23.76
,23.39
,23.31
,23.21
,26.44
,29.79
,30.78
,31.68
,31.18
,30.85
,30.66
,30.81
,31.06
,30.64
,32.48
,33.54
,33.80
,33.07
,32.45
,31.96
,29.04
,25.36
,23.36
,23.28
,22.94
,22.32
,22.48
,22.83
,24.96
,28.48
,30.36
,30.36
,29.73
,29.34
,29.43
,29.08
,28.79
,28.90
,30.02
,31.52
,32.12
,31.98
,31.47
,31.33
,28.67
,25.28
,23.50
,23.01
,22.76
,22.91
,22.90
,23.03
,25.40
,28.92
,31.06
,31.47
,31.12
,30.99
,30.77
,30.32
,30.23
,30.15
,30.78
,32.02
,32.47
,32.39
,31.67
,31.22
,28.32
,24.80
,22.73
,22.27
,22.17
,22.22
,22.18
,22.08
,24.50
,28.25
,30.44
,31.11
,30.93
,31.16
,31.19
,30.79
,29.66
,29.02
,29.01
,30.30
,31.00
,30.74
,29.91
,29.75
,27.26
,24.08
,22.13
,21.62
,21.33
,21.09
,21.07
,20.58
,21.30
,23.13
,24.73
,25.43
,25.16
,25.01
,25.00
,24.51
,24.42
,25.07
,26.60
,28.41
,28.86
,28.56
,28.18
,27.57
,25.33
,22.81
,20.92
,20.22
,20.26
,19.95
,19.52
,19.75
,20.50
,21.12
,23.38
,25.36
,26.59
,27.71
,28.10
,27.75
,27.15
,27.26
,28.09
,29.18
,29.61
,29.38
,29.02
,28.52
,26.52
,23.62
,22.03
,21.87
,21.56
,21.63
,21.83
,22.54
,24.77
,28.47
,30.68
,31.86
,31.87
,31.78
,31.60
,31.45
,31.18
,31.27
,31.72
,32.82
,33.10
,32.90
,32.45
,31.66
,28.71
,25.12
,24.12
,23.40
,22.83
,22.53
,22.49
,23.12
,24.98
,29.09
,31.49
,31.70
,31.48
,31.16
,31.88
,31.28
,31.17
,31.07
,31.72
,32.85
,33.05
,32.65
,32.16
,31.50
,28.35
,24.87
,23.06
,22.56
,22.11
,22.00
,21.92
,22.84
,24.63
,28.23
,30.52
,31.02
,30.27
,30.45
,29.99
,29.13
,28.58
,29.02
,30.27
,31.63
,32.00
,31.64
,31.35
,30.45
,27.14
,23.68
,22.10
,21.65
,21.31
,21.32
,21.44
,21.88
,24.48
,29.04
,32.10
,33.04
,32.34
,31.54
,30.55
,29.35
,28.84
,28.93
,29.96
,31.34
,31.86
,31.73
,31.46
,31.11
,27.94
,24.20
,22.19
,21.79
,21.48
,21.29
,21.37
,22.09
,24.31
,27.99
,29.63
,29.45
,28.79
,28.56
,28.34
,27.45
,27.17
,27.37
,28.10
,29.13
,29.38
,29.20
,29.10
,28.25
,25.71
,22.88
,20.85
,19.70
,19.10
,19.42
,19.06
,19.06
,20.15
,22.29
,25.01
,26.62
,26.95
,26.79
,26.37
,25.41
,24.51
,24.63
,26.03
,28.10
,29.12
,29.14
,28.98
,28.29
,26.23
,23.79
,21.68
,20.96
,20.93
,20.48
,20.22
,19.97
,20.21
,21.29
,22.41
,24.57
,25.93
,26.55
,26.65
,25.81
,25.27
,25.61
,27.00
,28.73
,29.45
,29.30
,29.43
,28.98
,27.10
,24.30
,22.91
,22.46
,21.99
,21.73
,22.12
,22.84
,25.71
,29.95
,32.31
,33.21
,33.14
,33.48
,33.62
,33.39
,33.10
,32.63
,34.42
,35.60
,35.57
,34.50
,34.32
,33.45
,30.11
,26.57
,25.17
,24.40
,23.92
,23.80
,23.87
,24.07
,27.27
,30.50
,32.98
,33.48
,33.26
,33.04
,32.79
,31.91
,30.31
,30.08
,31.32
,32.54
,33.14
,32.80
,32.35
,31.36
,28.10
,24.82
,23.56
,23.10
,22.52
,22.27
,22.37
,22.50
,25.21
,29.85
,31.50
,32.61
,32.40
,32.52
,30.87
,31.73
,31.23
,31.70
,32.86
,34.14
,34.06
,33.81
,33.85
,32.29
,29.01
,25.52
,24.13
,23.42
,22.96
,22.81
,22.82
,23.18
,25.74
,29.94
,31.86
,32.30
,30.54
,30.53
,30.23
,30.68
,30.58
,30.50
,31.13
,32.12
,32.12
,31.79
,32.01
,30.46
,27.95
,24.10
,22.26
,21.29
,21.16
,21.00
,21.11
,21.36
,23.78
,27.17
,28.80
,27.79
,27.74
,27.60
,27.69
,27.20
,27.19
,27.78
,29.04
,30.71
,31.68
,31.13
,30.86
,29.76
,27.05
,23.75
,21.66
,21.07
,20.57
,20.43
,20.34
,19.69
,20.77
,23.08
,24.71
,25.17
,24.71
,24.40
,24.23
,23.59
,22.91
,22.98
,24.52
,27.14
,28.52
,29.01
,29.42
,28.64
,26.60
,23.85
,21.77
,20.62
,19.90
,20.09
,20.07
,20.17
,20.64
,21.57
,23.04
,25.34
,26.85
,27.92
,28.61
,28.08
,27.03
,27.13
,27.98
,28.81
,29.06
,28.74
,28.95
,27.23
,25.00
,22.39
,21.36
,20.92
,20.74
,20.68
,20.02
,20.32
,21.80
,23.81
,25.29
,26.02
,26.05
,25.71
,25.84
,26.17
,26.31
,27.03
,28.50
,30.32
,31.27
,31.60
,31.78
,30.33
,27.28
,23.99
,21.87
,21.50
,21.48
,21.44
,20.76
,21.82
,25.47
,29.67
,31.96
,32.73
,32.37
,31.83
,31.65
,30.59
,30.42
,31.35
,32.62
,34.43
,34.88
,34.91
,34.99
,32.96
,29.16
,25.50
,24.18
,23.73
,23.11
,22.79
,23.02
,22.90
,26.19
,30.20
,32.87
,33.27
,32.92
,32.61
,32.27
,31.70
,31.22
,30.96
,31.29
,32.80
,33.78
,33.82
,33.88
,32.36
,29.07
,25.41
,24.13
,23.54
,23.04
,22.89
,22.86
,23.16
,26.17
,30.15
,32.38
,32.35
,31.22
,30.62
,30.68
,30.55
,30.59
,30.95
,32.41
,34.00
,34.34
,34.41
,34.98
,32.93
,29.36
,25.84
,24.23
,23.75
,23.32
,23.11
,23.23
,23.81
,25.92
,29.77
,31.23
,30.52
,28.88
,28.24
,28.02
,28.32
,28.41
,27.87
,28.91
,30.89
,31.71
,31.78
,31.93
,30.64
,27.46
,24.14
,22.54
,21.72
,21.13
,20.61
,20.51
,20.92
,21.56
,23.72
,26.00
,26.90
,26.57
,25.82
,25.18
,24.36
,23.94
,24.34
,26.11
,28.73
,29.89
,30.03
,30.13
,28.79
,26.38
,23.64
,21.48
,20.41
,19.89
,20.08
,20.12
,20.26
,20.74
,21.52
,23.00
,24.09
,24.17
,23.69
,23.29
,22.70
,22.66
,23.65
,25.97
,28.57
,30.07
,30.33
,30.70
,29.26
,26.76
,23.60
,21.88
,21.67
,21.44
,21.25
,21.47
,22.28
,25.71
,30.21
,32.85
,33.29
,32.37
,31.93
,31.69
,31.33
,31.49
,32.12
,33.54
,35.18
,35.49
,35.03
,35.04
,32.43
,28.56
,24.83
,23.40
,22.70
,22.45
,22.36
,22.60
,23.47
,26.65
,31.51
,33.91
,34.37
,33.65
,33.07
,33.27
,32.69
,32.34
,32.62
,34.49
,36.01
,36.04
,35.82
,35.80
,33.01
,29.00
,25.17
,23.51
,23.28
,22.89
,22.69
,22.76
,22.92
,27.17
,31.71
,33.36
,32.90
,32.13
,31.99
,32.07
,31.72
,31.27
,31.60
,33.30
,34.96
,35.04
,35.03
,35.14
,32.68
,28.93
,25.24
,23.13
,22.83
,22.73
,22.67
,22.78
,23.04
,27.79
,32.02
,32.68
,32.67
,32.54
,32.67
,33.08
,33.04
,33.16
,33.58
,34.67
,35.88
,35.99
,35.46
,35.50
,32.82
,28.52
,24.77
,22.50
,22.09
,21.98
,21.80
,21.94
,22.42
,26.24
,30.81
,31.41
,30.61
,29.95
,29.97
,29.91
,29.29
,28.73
,28.59
,30.29
,32.11
,32.68
,32.88
,33.02
,31.09
,27.78
,24.18
,21.88
,21.05
,20.44
,20.45
,20.73
,20.77
,22.23
,24.68
,27.55
,29.04
,29.17
,28.96
,28.30
,27.65
,26.81
,26.93
,28.04
,29.75
,30.42
,30.81
,30.54
,28.75
,26.27
,23.53
,21.44
,20.47
,20.46
,20.60
,20.33
,20.40
,21.00
,21.98
,22.91
,24.23
,24.62
,24.22
,24.00
,23.40
,23.19
,23.75
,25.66
,28.04
,29.38
,30.56
,30.97
,28.41
,25.18
,21.89
,20.59
,20.78
,20.78
,20.66
,20.74
,20.92
,25.07
,30.51
,32.33
,32.14
,31.71
,31.33
,30.75
,30.11
,29.84
,30.35
,32.43
,34.07
,34.36
,34.84
,34.04
,30.64
,26.62
,22.96
,22.48
,22.56
,22.62
,22.23
,22.37
,22.39
,25.47
,30.30
,32.48
,32.99
,32.40
,32.36
,32.31
,32.14
,31.92
,31.82
,33.20
,34.37
,34.78
,35.12
,34.61
,32.02
,28.07
,24.05
,21.84
,21.53
,21.28
,21.37
,21.51
,22.56
,27.11
,32.30
,34.08
,34.52
,33.94
,33.63
,33.16
,32.60
,32.22
,31.96
,33.48
,34.68
,35.21
,35.69
,35.90
,33.21
,28.88
,24.86
,22.52
,21.90
,21.96
,21.86
,21.97
,22.50
,27.34
,32.07
,32.40
,31.70
,30.86
,30.16
,30.00
,29.92
,29.94
,30.95
,32.30
,34.28
,35.07
,35.93
,35.35
,32.53
,28.36
,24.46
,22.20
,22.47
,22.27
,22.06
,22.14
,22.33
,26.47
,31.07
,32.55
,32.22
,31.21
,30.44
,30.40
,29.98
,29.45
,29.62
,31.25
,33.01
,33.59
,34.01
,33.56
,31.22
,27.83
,24.39
,22.61
,22.12
,21.47
,21.04
,20.77
,20.68
,22.76
,25.29
,27.58
,27.96
,27.50
,26.96
,26.75
,25.97
,25.58
,25.89
,27.53
,29.86
,30.98
,31.85
,30.80
,28.33
,25.58
,22.87
,20.89
,20.46
,20.80
,21.11
,20.47
,20.41
,21.24
,21.88
,23.18
,24.95
,25.75
,25.59
,25.55
,25.09
,25.14
,25.83
,28.24
,30.60
,31.73
,32.80
,32.34
,30.06
,26.88
,23.31
,22.00
,21.82
,21.62
,21.36
,21.54
,22.23
,26.59
,31.95
,33.63
,33.70
,32.97
,32.24
,31.32
,30.14
,29.33
,30.12
,31.53
,32.81
,33.57
,34.51
,33.39
,30.56
,27.24
,23.22
,22.40
,21.89
,21.57
,21.13
,20.83
,21.15
,25.00
,30.55
,32.01
,32.34
,31.56
,29.66
,29.53
,28.96
,29.06
,29.34
,31.05
,32.60
,33.16
,34.11
,33.02
,29.89
,25.87
,22.76
,21.76
,22.12
,22.00
,21.91
,21.96
,21.23
,25.03
,29.86
,30.76
,30.19
,29.82
,29.57
,29.23
,29.07
,29.51
,30.09
,31.66
,33.15
,33.36
,34.41
,33.33
,30.36
,26.64
,23.03
,21.16
,21.05
,20.93
,20.91
,21.15
,22.09
,26.70
,32.27
,33.67
,34.04
,34.21
,34.21
,34.49
,34.14
,33.79
,33.88
,35.86
,36.45
,36.14
,35.98
,34.66
,31.27
,27.13
,23.32
,21.33
,21.21
,20.94
,20.67
,20.55
,21.20
,24.86
,29.38
,29.78
,28.89
,27.79
,27.85
,28.03
,27.55
,27.43
,27.46
,29.41
,31.39
,32.51
,33.95
,33.24
,30.68
,27.24
,24.20
,22.91
,22.81
,22.43
,22.33
,22.37
,22.48
,22.80
,25.76
,28.99
,30.72
,31.35
,31.44
,31.32
,30.95
,30.44
,30.47
,31.45
,32.86
,33.27
,33.68
,32.66
,30.80
,28.02
,25.19
,23.25
,22.97
,22.25
,21.65
,21.59
,21.89
,22.75
,24.93
,27.00
,29.78
,30.53
,29.64
,28.22
,26.47
,25.47
,25.95
,27.89
,30.86
,32.78
,34.50
,33.60
,30.84
,27.81
,24.87
,23.66
,23.31
,22.66
,22.41
,22.65
,23.95
,28.29
,33.67
,34.46
,33.63
,31.89
,30.95
,30.80
,30.37
,30.49
,31.19
,33.76
,36.19
,37.79
,39.23
,37.52
,34.40
,30.21
,25.98
,24.41
,24.60
,24.29
,24.09
,24.29
,25.50
,29.41
,34.04
,34.46
,33.27
,31.05
,29.01
,28.77
,27.82
,27.64
,28.35
,31.26
,34.10
,35.85
,37.46
,35.46
,32.01
,27.62
,23.81
,22.74
,22.64
,22.37
,22.14
,22.17
,22.90
,27.26
,32.38
,33.08
,32.37
,31.11
,30.24
,29.89
,29.22
,28.81
,30.14
,33.04
,35.51
,36.32
,37.40
,36.18
,33.25
,28.87
,25.11
,22.69
,22.40
,22.22
,22.10
,21.80
,22.71
,27.71
,32.36
,32.96
,32.18
,30.39
,28.85
,28.52
,28.15
,28.26
,29.36
,32.26
,35.01
,36.54
,37.79
,36.34
,33.14
,29.08
,25.22
,24.47
,23.93
,23.66
,23.39
,23.36
,23.93
,28.03
,33.28
,34.18
,33.48
,32.13
,30.27
,30.73
,30.09
,29.49
,29.83
,31.92
,34.38
,36.12
,37.38
,35.56
,32.94
,29.51
,26.00
,23.47
,22.81
,22.59
,22.76
,22.76
,22.64
,24.58
,26.40
,28.26
,28.46
,27.11
,25.39
,24.37
,23.41
,22.83
,23.39
,25.79
,29.51
,31.80
,32.69
,31.47
,29.36
,26.69
,23.55
,21.73
,21.02
,20.83
,21.29
,21.07
,21.31
,21.68
,23.13
,25.35
,27.00
,27.31
,27.76
,26.96
,27.52
,27.25
,27.84
,29.25
,31.30
,32.53
,33.36
,32.24
,29.62
,26.06
,22.86
,21.75
,21.93
,21.94
,22.33
,22.33
,23.80
,28.54
,34.34
,35.35
,34.46
,32.95
,32.62
,32.50
,32.22
,32.24
,32.66
,35.04
,36.94
,38.33
,38.70
,35.89
,32.26
,27.85
,23.76
,21.85
,21.52
,21.99
,22.03
,22.01
,22.86
,27.40
,32.45
,34.19
,34.13
,33.04
,32.52
,32.15
,31.43
,31.19
,31.53
,34.25
,36.22
,37.46
,38.42
,36.42
,33.52
,29.45
,25.76
,23.40
,22.54
,22.74
,23.26
,23.54
,25.30
,29.62
,34.91
,36.01
,35.63
,34.60
,33.87
,33.46
,33.79
,33.04
,31.97
,33.94
,36.23
,37.75
,38.70
,36.59
,33.50
,29.23
,25.61
,23.49
,23.35
,23.18
,23.37
,23.65
,24.96
,28.76
,33.85
,35.16
,34.71
,34.67
,34.32
,33.23
,31.49
,30.54
,30.62
,33.34
,36.11
,38.30
,39.28
,37.11
,33.88
,29.94
,26.42
,25.21
,24.59
,24.17
,23.54
,23.53
,25.26
,29.03
,35.01
,36.41
,35.85
,35.44
,34.39
,33.83
,33.03
,33.01
,33.59
,35.34
,37.03
,38.10
,37.70
,35.82
,33.15
,29.84
,26.48
,25.28
,24.32
,23.60
,22.80
,22.80
,23.07
,24.54
,26.86
,30.03
,32.26
,32.74
,32.54
,31.89
,30.88
,30.22
,30.21
,31.33
,33.22
,34.40
,34.64
,32.92
,30.37
,28.09
,25.23
,23.49
,23.16
,23.15
,22.73
,22.44
,22.55
,23.89
,25.27
,26.48
,27.44
,27.56
,26.96
,26.32
,25.55
,25.91
,27.31
,29.57
,31.75
,33.37
,33.54
,31.77
,29.16
,25.78
,22.49
,20.71
,20.89
,20.97
,21.04
,21.29
,23.02
,27.61
,33.25
,34.69
,34.25
,33.22
,32.67
,32.63
,32.24
,32.11
,32.45
,34.78
,36.59
,37.88
,37.38
,34.88
,32.09
,29.30
,23.46
,21.71
,21.20
,21.30
,21.52
,21.44
,22.85
,27.69
,33.17
,33.09
,31.28
,30.67
,30.07
,29.56
,28.89
,29.03
,29.71
,32.47
,35.35
,37.29
,37.98
,35.59
,32.55
,28.62
,25.01
,23.24
,23.24
,23.09
,23.06
,23.13
,24.74
,28.86
,33.69
,34.02
,33.10
,31.39
,30.52
,29.52
,28.76
,28.69
,29.91
,32.86
,35.30
,37.16
,37.53
,34.85
,31.70
,27.89
,24.49
,22.81
,22.59
,22.93
,22.46
,22.47
,23.79
,27.65
,33.07
,33.97
,33.32
,32.24
,32.26
,32.49
,32.01
,32.54
,32.70
,34.83
,36.04
,37.57
,37.33
,34.66
,32.24
,28.33
,24.96
,22.66
,22.88
,22.69
,21.84
,21.27
,22.36
,25.67
,30.88
,32.18
,32.62
,32.79
,32.88
,32.92
,31.91
,31.37
,31.54
,33.14
,34.65
,35.83
,35.01
,32.57
,29.87
,26.63
,24.21
,22.96
,22.56
,22.04
,21.27
,21.02
,21.55
,22.68
,25.32
,28.22
,29.78
,30.02
,29.44
,28.42
,27.68
,27.23
,27.25
,28.36
,30.80
,32.72
,31.12
,28.93
,26.84
,24.59
,22.34
,21.82
,21.84
,21.14
,20.39
,20.40
,20.81
,22.13
,24.21
,26.91
,29.31
,30.85
,31.69
,32.94
,32.20
,31.62
,31.78
,33.33
,35.36
,36.91
,36.16
,33.89
,30.86
,27.75
,25.00
,24.12
,23.66
,23.45
,23.15
,23.09
,24.37
,28.38
,35.18
,37.36
,38.14
,37.98
,37.69
,37.54
,37.15
,36.96
,36.93
,38.82
,40.43
,41.66
,40.78
,37.84
,34.09
,30.12
,26.38
,24.78
,24.84
,24.72
,24.08
,24.08
,25.44
,30.01
,34.54
,35.70
,36.10
,36.74
,36.12
,35.30
,34.35
,34.14
,34.05
,36.52
,38.13
,39.92
,39.38
,36.72
,33.28
,29.65
,25.65
,24.68
,24.55
,24.33
,23.97
,24.07
,25.34
,30.58
,36.61
,37.46
,37.35
,37.25
,37.41
,37.11
,35.72
,35.10
,35.70
,37.55
,39.68
,41.37
,41.06
,38.27
,34.77
,30.64
,27.11
,25.48
,25.66
,25.46
,24.96
,25.05
,26.33
,30.63
,36.78
,37.86
,36.90
,35.53
,34.63
,33.76
,33.15
,33.18
,34.07
,36.30
,38.84
,40.96
,40.75
,38.60
,35.11
,30.71
,26.60
,24.58
,24.72
,24.59
,24.03
,23.98
,25.75
,30.08
,35.15
,37.03
,35.88
,34.73
,33.75
,32.75
,31.29
,31.24
,32.18
,35.18
,37.54
,39.62
,38.60
,36.69
,33.45
,29.91
,26.34
,23.90
,24.21
,24.21
,23.35
,22.07
,23.51
,24.92
,27.64
,30.11
,30.69
,29.72
,28.48
,27.11
,26.03
,25.47
,26.35
,28.81
,32.01
,34.67
,33.98
,31.74
,29.68
,27.46
,24.63
,22.64
,22.48
,22.49
,21.73
,21.25
,21.59
,22.79
,23.88
,26.04
,27.12
,27.04
,26.52
,26.10
,25.54
,25.64
,27.36
,30.09
,32.49
,34.36
,33.53
,31.80
,29.31
,26.55
,23.72
,22.49
,22.55
,22.25
,21.97
,21.88
,23.09
,27.87
,34.18
,36.61
,35.53
,33.62
,32.08
,31.21
,30.50
,30.51
,31.57
,34.11
,37.32
,39.68
,38.89
,36.13
,32.57
,28.51
,24.43
,22.43
,22.51
,22.35
,21.70
,21.80
,23.09
,27.06
,32.68
,34.58
,34.50
,33.13
,31.85
,31.25
,30.81
,31.26
,32.42
,34.80
,37.48
,39.16
,38.26
,35.45
,31.66
,27.95
,24.57
,23.01
,22.98
,23.22
,22.55
,22.49
,23.77
,27.66
,33.92
,36.05
,35.70
,33.88
,32.79
,32.07
,32.65
,32.54
,32.75
,35.03
,38.07
,40.39
,39.32
,36.97
,33.71
,29.69
,26.86
,25.22
,24.90
,24.77
,24.29
,24.09
,25.31
,29.81
,36.55
,37.41
,36.96
,35.85
,35.14
,34.89
,35.13
,35.43
,36.20
,37.13
,39.72
,41.36
,39.87
,37.08
,33.36
,29.87
,25.77
,23.63
,24.11
,24.17
,23.47
,23.09
,24.55
,28.79
,33.87
,36.32
,36.18
,34.91
,34.67
,33.25
,32.63
,32.47
,32.95
,33.74
,36.76
,39.02
,37.64
,35.23
,32.06
,29.27
,25.73
,23.57
,23.33
,23.72
,23.36
,22.86
,23.18
,25.27
,28.80
,31.87
,32.31
,31.59
,30.86
,30.86
,30.82
,31.09
,31.55
,33.39
,36.54
,38.15
,36.68
,34.36
,31.76
,29.16
,26.79
,24.91
,24.61
,24.39
,24.14
,24.12
,23.86
,24.24
,25.47
,27.66
,30.47
,31.29
,30.87
,30.71
,31.36
,31.88
,32.72
,34.73
,38.27
,41.95
,40.96
,39.14
,36.79
,33.72
,30.29
,27.14
,26.28
,25.97
,25.54
,25.99
,26.02
,28.06
,32.69
,38.58
,39.83
,39.44
,38.07
,37.24
,37.46
,38.39
,39.12
,41.06
,43.11
,46.12
,45.58
,43.58
,40.40
,38.27
,34.28
,28.56
,28.10
,28.54
,28.49
,27.63
,27.22
,29.20
,34.68
,40.28
,41.53
,40.60
,40.68
,40.22
,40.38
,40.48
,40.55
,41.32
,44.26
,47.20
,46.59
,44.52
,41.83
,38.15
,34.07
,29.86
,29.72
,29.84
,28.99
,28.20
,28.05
,29.90
,35.17
,39.23
,40.03
,39.83
,39.83
,39.16
,39.76
,39.84
,40.30
,41.02
,43.21
,45.22
,43.59
,42.01
,39.82
,36.24
,32.24
,29.19
,28.32
,28.52
,28.08
,27.39
,27.26
,28.61
,32.17
,37.34
,39.31
,39.27
,39.00
,39.15
,38.88
,38.83
,39.17
,40.32
,42.70
,44.67
,44.38
,43.24
,40.62
,36.84
,32.74
,29.29
,28.21
,28.49
,28.31
,27.91
,27.79
,28.92
,33.08
,38.20
,39.05
,38.26
,36.73
,35.91
,35.31
,35.24
,36.09
,37.85
,41.03
,43.72
,42.60
,40.33
,37.48
,34.57
,31.51
,26.41
,25.19
,24.11
,23.38
,22.64
,21.99
,22.49
,24.42
,27.46
,28.91
,30.42
,30.27
,29.96
,29.94
,29.85
,30.17
,30.93
,33.83
,36.83
,35.49
,32.94
,30.91
,29.08
,27.54
,24.22
,23.56
,23.25
,22.39
,22.38
,22.11
,22.04
,23.17
,24.47
,27.18
,30.12
,31.22
,31.98
,32.77
,33.21
,34.05
,35.54
,38.75
,40.54
,39.43
,37.49
,35.42
,32.83
,29.55
,26.36
,26.42
,26.73
,25.99
,25.23
,25.02
,26.75
,31.48
,37.16
,38.22
,39.40
,39.06
,38.74
,38.62
,38.08
,38.33
,39.29
,42.32
,44.05
,43.04
,41.15
,38.60
,34.89
,31.04
,27.25
,26.21
,25.75
,25.74
,25.12
,24.79
,26.36
,30.58
,35.35
,36.44
,37.00
,36.71
,36.59
,36.24
,35.96
,36.16
,37.04
,39.73
,42.17
,41.23
,39.36
,36.59
,32.98
,28.63
,25.72
,25.97
,25.88
,25.29
,24.41
,23.94
,25.00
,29.20
,34.76
,36.30
,36.74
,36.34
,36.43
,36.00
,35.75
,36.03
,37.50
,41.10
,43.33
,42.70
,41.33
,38.66
,34.86
,31.26
,27.72
,27.17
,26.85
,26.02
,25.44
,25.50
,26.84
,30.90
,36.30
,37.14
,36.03
,35.48
,35.62
,35.97
,35.95
,36.11
,37.81
,41.53
,43.31
,42.78
,40.82
,37.67
,33.70
,29.72
,26.21
,25.20
,24.85
,24.78
,24.47
,24.45
,25.63
,30.17
,35.31
,36.72
,36.77
,36.53
,36.24
,36.26
,35.81
,35.60
,36.16
,38.88
,40.58
,39.81
,37.93
,34.91
,31.39
,28.18
,25.36
,24.63
,24.53
,24.01
,23.68
,23.22
,23.74
,25.44
,28.39
,30.71
,31.82
,32.33
,32.49
,32.96
,32.92
,33.42
,34.68
,37.57
,40.08
,39.09
,37.17
,34.75
,32.15
,30.01
,27.40
,27.16
,26.39
,25.34
,24.33
,23.98
,23.93
,25.12
,26.46
,28.51
,30.11
,30.19
,29.94
,30.55
,30.59
,31.50
,33.67
,37.57
,40.03
,38.67
,36.74
,34.35
,31.39
,28.14
,25.69
,25.35
,25.13
,24.15
,23.58
,23.71
,25.45
,29.86
,35.41
,37.20
,36.91
,36.11
,35.41
,35.32
,36.59
,37.63
,38.39
,41.83
,44.11
,43.05
,40.88
,37.46
,33.73
,29.35
,26.23
,25.00
,25.40
,24.74
,24.21
,24.30
,25.69
,30.19
,35.79
,36.71
,35.53
,34.35
,33.69
,33.60
,34.07
,35.16
,37.22
,41.38
,43.23
,42.72
,40.81
,37.48
,33.66
,29.18
,25.78
,24.75
,24.82
,24.21
,23.53
,23.38
,24.69
,29.66
,34.92
,35.77
,35.19
,34.38
,33.14
,33.72
,33.78
,34.65
,36.93
,40.77
,43.02
,42.01
,40.48
,37.63
,33.89
,29.92
,26.50
,25.73
,25.54
,25.05
,24.42
,24.32
,25.82
,30.21
,35.33
,36.44
,37.13
,36.52
,36.18
,36.34
,36.47
,36.94
,38.24
,41.86
,43.93
,43.41
,41.39
,39.02
,35.78
,31.52
,28.13
,27.70
,27.14
,26.20
,25.55
,25.46
,26.87
,31.48
,36.61
,38.28
,38.67
,38.55
,38.63
,38.49
,38.47
,38.76
,39.13
,41.12
,42.44
,41.49
,39.58
,36.80
,33.57
,30.33
,27.58
,27.57
,26.88
,25.57
,24.67
,24.09
,24.61
,26.07
,28.66
,31.35
,32.52
,32.20
,31.24
,30.23
,29.99
,30.49
,32.20
,36.10
,38.64
,37.90
,35.60
,33.44
,31.00
,28.44
,25.97
,25.66
,25.92
,24.88
,23.87
,23.41
,23.70
,25.28
,26.38
,28.30
,29.72
,30.01
,29.82
,30.00
,30.35
,31.61
,34.14
,38.65
,40.53
,39.35
,37.25
,35.35
,32.42
,28.99
,26.28
,26.42
,26.04
,25.20
,24.68
,24.88
,26.55
,31.56
,37.77
,39.95
,40.95
,41.14
,40.89
,41.07
,40.82
,41.31
,41.69
,44.42
,45.77
,45.47
,43.71
,41.61
,38.25
,34.01
,29.31
,27.68
,27.57
,26.56
,26.07
,26.64
,27.41
,32.28
,38.28
,41.02
,42.10
,42.51
,42.38
,43.14
,42.40
,42.72
,43.74
,46.10
,46.96
,46.98
,45.29
,42.81
,39.22
,34.69
,31.10
,30.79
,29.97
,28.75
,28.94
,29.49
,31.28
,35.62
,41.67
,43.53
,43.86
,43.73
,43.74
,43.70
,43.59
,43.90
,44.82
,45.75
,46.03
,47.72
,46.71
,44.75
,40.85
,36.73
,33.76
,33.30
,31.91
,30.52
,30.00
,31.53
,33.11
,37.65
,43.64
,45.11
,45.03
,44.23
,44.07
,44.22
,44.25
,44.42
,44.50
,46.51
,46.19
,45.68
,45.76
,43.24
,39.57
,35.71
,33.79
,32.10
,31.53
,29.96
,29.89
,30.79
,32.85
,36.79
,41.95
,43.65
,44.18
,43.78
,43.31
,43.12
,42.89
,43.05
,43.75
,45.04
,45.86
,45.55
,43.50
,40.44
,36.91
,33.19
,29.94
,29.24
,28.87
,28.41
,27.57
,26.84
,26.98
,28.83
,31.15
,34.65
,37.02
,37.38
,37.11
,37.22
,37.51
,37.52
,38.09
,40.56
,42.31
,41.37
,38.97
,36.66
,34.06
,31.17
,28.57
,28.08
,27.55
,26.93
,26.33
,26.03
,26.02
,27.47
,28.49
,30.45
,33.31
,34.83
,35.48
,36.28
,36.59
,37.06
,38.67
,42.01
,43.36
,42.43
,39.89
,37.54
,34.61
,31.42
,28.36
,28.59
,29.06
,28.27
,27.77
,27.68
,28.78
,34.52
,41.76
,43.89
,43.88
,43.19
,42.78
,42.66
,42.71
,43.14
,43.81
,45.59
,46.10
,45.67
,44.88
,42.90
,39.76
,35.42
,31.01
,30.49
,30.21
,29.52
,28.88
,28.31
,30.29
,35.14
,40.66
,42.13
,42.74
,42.67
,42.44
,42.75
,43.34
,44.25
,45.06
,46.69
,46.35
,46.22
,43.88
,40.81
,36.92
,32.68
,28.97
,28.09
,27.84
,27.57
,27.38
,26.92
,27.74
,31.65
,36.95
,38.49
,39.19
,39.01
,39.21
,39.25
,39.02
,38.99
,39.77
,42.21
,43.17
,42.33
,40.26
,37.57
,33.78
,29.75
,26.54
,26.49
,26.59
,26.05
,25.57
,25.30
,25.62
,30.33
,36.54
,37.90
,38.35
,37.84
,37.76
,37.41
,36.59
,36.89
,38.52
,41.56
,42.75
,41.63
,39.93
,37.48
,33.85
,29.92
,26.47
,26.38
,26.43
,25.21
,24.65
,24.86
,26.05
,30.03
,36.06
,37.52
,37.15
,35.83
,35.16
,35.10
,35.35
,36.25
,37.82
,41.43
,42.81
,41.96
,40.64
,38.17
,35.05
,32.02
,28.89
,27.60
,26.66
,25.56
,25.23
,24.99
,25.27
,27.11
,30.87
,34.21
,36.78
,37.60
,37.28
,36.96
,36.47
,36.28
,37.12
,39.62
,40.85
,40.19
,38.31
,35.83
,32.87
,30.47
,27.83
,26.76
,25.98
,24.93
,24.40
,23.94
,24.24
,25.55
,26.70
,28.88
,31.41
,32.60
,33.33
,34.29
,34.14
,34.34
,35.62
,38.59
,39.99
,39.17
,36.83
,34.23
,31.36
,28.03
,25.45
,24.78
,25.33
,24.93
,24.42
,23.93
,25.18
,29.90
,37.32
,39.74
,40.34
,40.10
,39.90
,39.86
,39.55
,40.07
,41.63
,45.10
,46.26
,45.60
,43.50
,41.49
,38.20
,34.17
,30.83
,29.82
,29.75
,29.65
,29.08
,29.02
,30.26
,34.47
,41.75
,43.22
,43.17
,42.19
,42.00
,42.82
,43.00
,43.46
,44.81
,46.37
,46.66
,46.19
,44.98
,42.65
,38.62
,34.32
,30.57
,29.80
,29.63
,30.11
,29.43
,29.06
,29.67
,33.88
,40.01
,41.99
,43.00
,42.77
,43.69
,44.09
,43.87
,43.54
,44.63
,46.55
,46.71
,46.02
,44.97
,41.95
,37.70
,33.76
,29.66
,28.28
,28.31
,27.84
,27.63
,27.28
,28.06
,31.85
,37.54
,38.97
,39.13
,38.83
,38.65
,38.60
,38.68
,39.04
,40.46
,43.82
,44.63
,43.60
,42.07
,39.22
,35.63
,31.55
,27.65
,26.13
,26.35
,25.48
,24.46
,23.69
,24.50
,28.78
,34.98
,37.14
,38.03
,37.71
,36.78
,36.36
,35.67
,35.81
,37.37
,41.16
,42.38
,41.12
,38.35
,35.79
,32.50
,29.13
,26.21
,25.46
,24.98
,25.05
,24.58
,23.33
,23.35
,24.88
,27.06
,30.50
,32.61
,32.77
,32.77
,33.29
,33.66
,33.95
,34.99
,38.49
,39.88
,38.80
,36.23
,33.83
,31.15
,28.66
,26.05
,25.34
,25.12
,24.57
,24.22
,23.63
,24.03
,24.84
,26.04
,28.83
,31.27
,32.34
,32.41
,32.74
,33.18
,34.13
,36.46
,40.38
,41.91
,40.84
,39.80
,37.79
,34.71
,31.73
,29.36
,29.09
,29.10
,28.27
,28.07
,27.98
,29.47
,33.74
,40.77
,42.64
,42.62
,41.65
,41.63
,42.51
,42.89
,43.27
,44.68
,46.85
,46.81
,46.74
,45.62
,43.18
,39.00
,34.51
,30.73
,29.83
,30.20
,30.16
,29.53
,29.21
,30.00
,34.65
,41.17
,42.85
,43.10
,41.82
,41.47
,41.42
,41.36
,41.57
,43.02
,45.77
,46.29
,46.29
,45.37
,42.42
,38.30
,34.10
,30.49
,29.80
,29.48
,28.84
,28.11
,27.94
,28.02
,34.56
,41.10
,42.81
,42.65
,42.07
,41.64
,41.61
,41.16
,41.43
,42.10
,44.17
,44.44
,43.78
,43.00
,40.57
,36.46
,32.02
,28.43
,27.46
,27.34
,27.18
,26.61
,26.01
,26.81
,32.84
,40.66
,42.54
,42.73
,42.19
,41.75
,41.57
,40.55
,40.95
,42.89
,45.11
,45.14
,45.38
,44.77
,42.61
,39.11
,34.82
,31.09
,30.74
,30.94
,30.28
,29.81
,29.50
,30.26
,36.28
,42.55
,44.46
,45.18
,44.57
,44.38
,44.31
,43.90
,43.92
,44.72
,45.52
,45.19
,44.97
,44.36
,41.43
,38.64
,34.11
,30.11
,29.11
,28.71
,28.10
,27.59
,26.81
,26.72
,28.46
,31.30
,34.40
,37.27
,38.48
,38.86
,39.25
,39.50
,39.71
,40.67
,42.61
,43.61
,42.05
,39.17
,36.83
,34.28
,31.25
,28.59
,27.93
,27.53
,27.09
,26.65
,26.11
,25.88
,27.26
,28.94
,32.00
,34.61
,36.18
,37.40
,38.36
,38.83
,39.42
,40.99
,43.90
,44.75
,43.75
,41.44
,38.94
,35.92
,32.53
,30.03
,29.19
,29.31
,29.12
,28.26
,28.02
,29.31
,34.03
,40.91
,43.05
,43.17
,41.42
,41.48
,41.86
,41.89
,42.42
,43.87
,45.41
,45.19
,44.78
,42.91
,39.80
,35.83
,31.23
,27.62
,26.85
,27.18
,26.25
,25.21
,24.56
,25.10
,30.18
,36.33
,38.51
,39.29
,39.42
,39.93
,40.21
,40.45
,40.76
,42.14
,45.09
,46.19
,45.59
,43.75
,41.16
,37.15
,33.00
,29.37
,28.32
,28.12
,27.68
,27.25
,27.14
,28.38
,32.96
,39.11
,40.68
,40.78
,40.21
,39.27
,39.01
,38.88
,39.70
,41.21
,44.26
,45.30
,44.49
,42.88
,40.18
,36.73
,32.65
,28.88
,28.09
,27.87
,27.53
,26.70
,26.60
,28.23
,32.47
,38.30
,40.36
,40.17
,39.20
,38.39
,38.19
,38.40
,39.35
,40.52
,42.97
,44.25
,43.55
,42.21
,40.15
,36.71
,33.04
,29.93
,28.79
,28.76
,28.23
,27.54
,27.27
,27.72
,31.21
,36.61
,38.40
,38.91
,38.61
,38.20
,37.65
,37.65
,37.92
,38.79
,41.09
,42.28
,40.97
,39.70
,37.04
,33.95
,30.62
,27.51
,26.51
,25.46
,24.69
,24.53
,23.89
,24.43
,25.57
,28.08
,30.81
,32.62
,32.49
,32.16
,32.06
,32.19
,32.92
,34.74
,37.98
,39.37
,39.06
,37.63
,35.60
,32.91
,30.60
,28.29
,27.51
,27.08
,26.28
,25.90
,25.53
,25.58
,26.16
,27.36
,30.16
,33.32
,35.22
,36.30
,36.88
,36.89
,36.93
,37.88
,39.91
,40.93
,40.25
,38.71
,36.69
,34.05
,31.34
,28.59
,27.75
,27.14
,27.01
,27.29
,26.91
,27.08
,28.54
,31.99
,35.03
,37.26
,37.63
,37.34
,36.94
,36.47
,36.62
,37.77
,40.59
,41.50
,40.24
,38.34
,36.09
,33.50
,30.80
,27.88
,26.56
,26.29
,26.14
,25.57
,24.95
,25.03
,26.60
,28.04
,30.65
,33.61
,34.90
,35.80
,36.93
,36.94
,35.65
,33.79
,32.93
,31.99
,30.84
,30.07
,29.36
,28.06
,26.55
,24.87
,24.62
,24.85
,23.83
,23.09
,22.82
,22.76
,23.45
,24.44
,26.57
,29.45
,31.17
,31.92
,32.64
,32.74
,32.63
,33.37
,35.33
,36.02
,35.21
,34.22
,32.81
,30.69
,28.67
,26.43
,26.39
,26.26
,25.82
,25.61
,25.57
,25.16
,26.63
,29.82
,33.22
,35.54
,36.44
,36.74
,36.81
,36.65
,36.90
,38.14
,40.87
,42.17
,41.29
,39.71
,37.60
,34.28
,31.28
,28.18
,27.08
,26.51
,26.51
,25.72
,25.17
,25.75
,26.92
,29.76
,32.20
,35.33
,36.32
,36.50
,36.60
,36.52
,36.78
,38.02
,40.24
,41.44
,40.66
,38.69
,35.93
,32.77
,29.83
,26.72
,25.36
,24.40
,23.25
,23.06
,22.16
,22.12
,23.24
,24.99
,26.67
,29.31
,30.94
,31.70
,32.01
,31.97
,32.31
,34.01
,37.48
,39.34
,38.40
,36.59
,35.20
,32.87
,30.44
,27.68
,26.61
,25.54
,24.52
,24.70
,24.52
,24.22
,25.02
,25.56
,27.16
,30.23
,32.17
,33.17
,34.06
,34.08
,34.19
,35.27
,37.95
,39.17
,38.13
,36.20
,33.85
,31.33
,28.85
,26.10
,25.02
,24.85
,24.43
,23.91
,23.30
,23.75
,25.27
,27.18
,29.71
,32.43
,34.04
,34.10
,34.63
,34.75
,34.81
,35.43
,37.94
,39.01
,37.38
,34.50
,31.61
,28.93
,27.19
]

export const UK_demand_GW_2018: DataSeriesOverTime<number> = {
    data: UK_demand_GW_by_hour_2018,
    start_timestamp_ms: new Date("2018-01-01T00:00:00Z").getTime(),
    end_timestamp_ms: new Date("2019-01-01T00:00:00Z").getTime(),
    timestep_ms: 3600_000,  // 1 hour in milliseconds
}
